<div class="cases_page board_global_page" [ngClass]="{'use_out': useOut}">
    <div class="container">
      <div class="filter_out" *ngIf="!is_mobile">  
        <form *ngIf="showFilter" [formGroup]="filter" class="filter_in" (ngSubmit)="filterData()" >
            <div class="filter_form_in">
      
              <div class="d-f-c">
                <mat-form-field appearance="legacy" class="filter_form search">
                  <!-- <mat-label>{{ 'Search' | translate }}</mat-label> -->
                  <mat-icon matPrefix>search</mat-icon>
                  <input formControlName="q" matInput>
                  <mat-icon (click)="$event.stopPropagation();" matSuffix>tune</mat-icon>
                </mat-form-field>
                <button type="submit" class="filter_btn search_filter_btn">{{ "Search" | translate }}</button>
              </div>

          
              <mat-form-field appearance="legacy" class="filter_form executor">
                <mat-label>{{ "Executor" | translate }}</mat-label>
                <mat-select [disableOptionCentering]="true" selectDir formControlName="operation_employee_id"  (selectionChange)="selectChange($event)">
                  <mat-option>
                    <ngx-mat-select-search 
                        placeholderLabel="{{ 'Search' | translate }}" 
                        noEntriesFoundLabel="{{ 'no matching member found' | translate }}"
                        [formControl]="execControl"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                    <app-user [class]="'user_div'" [employee]="employee"></app-user>
                  </mat-option>
                </mat-select>
              </mat-form-field>
      
              <mat-form-field appearance="legacy" class="filter_form status">
                <mat-label>{{ "Status" | translate }}</mat-label>
                <mat-select formControlName="status_id" [multiple]="true">
                <mat-option *ngFor="let status of statuses" [value]="status.id">
                    {{ status.name | translate }}
                </mat-option>
                </mat-select>
              </mat-form-field>
          
              <mat-form-field appearance="legacy" class="example-form-field filter_form date">
                <mat-label>{{ 'Date' | translate }}</mat-label>
                <mat-date-range-input  [rangePicker]="rangePicker">
                    <input formControlName="start_at_from" matStartDate placeholder="{{ 'Date from' | translate }}">
                    <input formControlName="start_at_to" matEndDate placeholder="{{ 'Date to' | translate }}">
                </mat-date-range-input>
                <mat-datepicker-toggle matPrefix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                  <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" (click)="filterData()" matDateRangePickerApply>Apply</button>
                  </mat-date-range-picker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            </div>
            <div class="d-f-c icons_board">
              <a href="/board-list?company_id={{company?.id}}&count=1" (click)="goToPlaningBoard($event)">
                <svg style="width: 20px; height: 15px;" width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 15H20V13H12V15ZM12 9.5H20V7.5H12V9.5ZM12 4H20V2H12V4ZM0 8.5C0 4.92 2.92 2 6.5 2H7V0L10 3L7 6V4H6.5C4 4 2 6 2 8.5C2 11 4 13 6.5 13H10V15H6.5C2.92 15 0 12.08 0 8.5Z" fill="#686868"/>
                </svg>
              </a>
              <a class="active">
                <svg style="width: 18px; height: 20px;" width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 13H4V15H11M16 18H2V7H16M16 2H15V0H13V2H5V0H3V2H2C0.89 2 0 2.9 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM14 9H4V11H14V9Z" fill="#686868"/>
                </svg>
              </a>
            </div>
          </form>
          <div class="filter_values">
            <mat-chip-list class="chips_wrp without_ordered start_page_chips">
              
              <mat-chip class="user_chip" (removed)="removeValue('channel_platform_id')" *ngIf="!!activatedRoute.snapshot.queryParamMap.get('channel_platform_id') || filter.get('priority').value || (!!activatedRoute.snapshot.queryParamMap.get('channel_platform_id') && activatedRoute.snapshot.queryParamMap.get('channel_platform_id').toString() == '0')">
                <div class="platform_wrp">
                  <div>
                    <app-platform [platform_id]="activatedRoute.snapshot.queryParamMap.get('channel_platform_id')"></app-platform>
                  </div>
                  {{ getPlatformById(activatedRoute.snapshot.queryParamMap.get('channel_platform_id'))?.name }}
                </div>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
              <mat-chip class="red_chip" (removed)="removeValue('no_operation_id')" *ngIf="filter.get('no_operation_id').value">
                {{ "Not assigned" | translate }}: {{ getColumnName(filter.get('no_operation_id').value) }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
              
            <ng-container *ngIf="filter.get('task_parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for task" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('task_parameter_value_id').value" (removed)="removeValueFromMultiple('task_parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-container *ngIf="filter.get('task_operation_parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for job" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('task_operation_parameter_value_id').value" (removed)="removeValueFromMultiple('task_operation_parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-container *ngIf="filter.get('discussion_parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for chat" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('discussion_parameter_value_id').value" (removed)="removeValueFromMultiple('discussion_parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-container *ngIf="filter.get('file_parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for file" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('file_parameter_value_id').value" (removed)="removeValueFromMultiple('file_parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
  
            <ng-container *ngIf="filter.get('parameter_value_id').value.length">
              <span class="chip_out_label">{{ "Tag for everywhere" | translate }}</span>
              <mat-chip *ngFor="let forTaskParamValueId of filter.get('parameter_value_id').value" (removed)="removeValueFromMultiple('parameter_value_id', forTaskParamValueId)">
                 {{ getValueById(forTaskParamValueId)?.value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
            </ng-container>
            <mat-chip (removed)="removeValue('task_custom_id')" *ngIf="filter?.get('task_custom_id')?.value">
              {{ "Card custom ID" | translate }}: {{ filter?.get('task_custom_id')?.value }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>
            <mat-chip (removed)="removeValue('is_content_url')" *ngIf="filter.get('is_content_url').value || filter?.get('is_content_url').value == '0'">
              {{ contentUrl[filter.get('is_content_url').value].name }}
              <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
            </mat-chip>

              <mat-chip (removed)="removeValue('q')" *ngIf="filter.get('q').value">
                {{filter.get('q').value}}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
      
              <mat-chip class="user_chip" [ngClass]="{'is_real': !!getEmployee(filter.get('operation_employee_id').value)?.user_id}" (removed)="removeValue('operation_employee_id')" *ngIf="filter.get('operation_employee_id').value">
                <app-user [class]="'user_div'" [employee]="getEmployee(filter.get('operation_employee_id').value)"></app-user>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>

              <ng-container *ngIf="filter.get('channel_id').value.length">
                <span class="chip_out_label">{{ "Card Outlets" | translate }}</span>
                <mat-chip [ngClass]="{'user_chip': id != 0}" *ngFor="let id of filter.get('channel_id').value" (removed)="removeValueFromMultiple('channel_id', id)">
                  <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
                    <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
                  </ng-container>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
    
              <ng-container *ngIf="filter.get('no_channel_id').value.length">
                <span class="chip_out_label">{{ "Not Presented" | translate }}</span>
                <mat-chip [ngClass]="{'user_chip': id != 0}" *ngFor="let id of filter.get('no_channel_id').value" (removed)="removeValueFromMultiple('no_channel_id', id)">
                  <ng-container *ngIf="id != 0; else elseTemplateOutletNotSet">
                    <app-outlet-line [channel]="getProfile(id)" [company_id]="company_id"></app-outlet-line>
                  </ng-container>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
    
              <ng-template #elseTemplateOutletNotSet>
                {{ "Not Set" | translate}}
              </ng-template>
              
              <mat-chip class="user_chip" (removed)="removeValue('origin_company_id')" *ngIf="filter.get('origin_company_id').value && getPartner(filter.get('origin_company_id').value)">
                {{ "Partner Client" | translate }}:
                <app-user [class]="'user_div ml-1'" [companyEmployee]="getPartner(filter.get('origin_company_id').value)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="company"></app-user>
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>

              <mat-chip (removed)="removeValue('task_operation_operation_id')" *ngIf="filter.get('task_operation_operation_id').value">
                {{ getColumnName(filter.get('task_operation_operation_id').value) }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
              
              <mat-chip (removed)="removeValue('discussion_id')" *ngIf="filter.get('discussion_id').value">
                {{ filter.get('discussion_id').value }}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>

              <mat-chip (removed)="removeValue('priority')" *ngIf="filter.get('priority').value">
                {{getPriority(filter.get('priority').value)?.name | translate}}
                <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
              </mat-chip>
<!-- 
              <ng-container *ngIf="filter.get('status_id').value.length > 0">
                <ng-container *ngFor="let status of filter.get('status_id').value">
                    <mat-chip (removed)="removeValue('status_id', status)" >
                      {{ getOperationStatusName(status) }}
                      <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                    </mat-chip>
                </ng-container>
              </ng-container> -->


              <!-- filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0' -->
              <ng-container *ngIf="filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0'">
                <span class="chip_out_label">{{ "Card Added" | translate }}</span>

                <div class="chip_splash"></div>
                
                <ng-container *ngIf="filter.get('task_created_at_from').value">
                  <span class="small_chip_out_label">{{ "from" | translate}}</span>
                  <mat-chip (removed)="removeValue('task_created_at_from')">
                    {{ filter?.get('task_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
        
                <ng-container *ngIf="filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0'">
                  <span class="small_chip_out_label">{{ "to" | translate}}</span>
                  <mat-chip (removed)="removeValue('task_created_at_to')">
                    <ng-container *ngIf="filter.get('task_created_at_to').value == 0; else elseTemplateCompletedFilter">
                      {{ "Without date" | translate }}
                    </ng-container>
                    <ng-template #elseTemplateCompletedFilter>
                      {{ filter?.get('task_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    </ng-template>
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0'">
                <span class="chip_out_label">{{ "Job added" | translate }}</span>

                <div class="chip_splash"></div>
                
                <ng-container *ngIf="filter.get('task_operation_created_at_from').value">
                  <span class="small_chip_out_label">{{ "from" | translate}}</span>
                  <mat-chip (removed)="removeValue('task_operation_created_at_from')">
                    {{ filter?.get('task_operation_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
        
                <ng-container *ngIf="filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0'">
                  <span class="small_chip_out_label">{{ "to" | translate}}</span>
                  <mat-chip (removed)="removeValue('task_operation_created_at_to')">
                    <ng-container *ngIf="filter.get('task_operation_created_at_to').value == 0; else elseTemplateCompletedFilter">
                      {{ "Without date" | translate }}
                    </ng-container>
                    <ng-template #elseTemplateCompletedFilter>
                      {{ filter?.get('task_operation_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    </ng-template>
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0'">
                <span class="chip_out_label">{{ "Job completed" | translate }}</span>

                <div class="chip_splash"></div>
                
                <ng-container *ngIf="filter.get('task_operation_completed_at_from').value">
                  <span class="small_chip_out_label">{{ "from" | translate}}</span>
                  <mat-chip (removed)="removeValue('task_operation_completed_at_from')">
                    {{ filter?.get('task_operation_completed_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
        
                <ng-container *ngIf="filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0'">
                  <span class="small_chip_out_label">{{ "to" | translate}}</span>
                  <mat-chip (removed)="removeValue('task_operation_completed_at_to')">
                    <ng-container *ngIf="filter.get('task_operation_completed_at_to').value == 0; else elseTemplateCompletedFilter">
                      {{ "Without date" | translate }}
                    </ng-container>
                    <ng-template #elseTemplateCompletedFilter>
                      {{ filter?.get('task_operation_completed_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    </ng-template>
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0'">
                <span class="chip_out_label">{{ "Chat added" | translate }}</span>

                <div class="chip_splash"></div>
                
                <ng-container *ngIf="filter.get('discussion_created_at_from').value">
                  <span class="small_chip_out_label">{{ "from" | translate}}</span>
                  <mat-chip (removed)="removeValue('discussion_created_at_from')">
                    {{ filter?.get('discussion_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
        
                <ng-container *ngIf="filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0'">
                  <span class="small_chip_out_label">{{ "to" | translate}}</span>
                  <mat-chip (removed)="removeValue('discussion_created_at_to')">
                    <ng-container *ngIf="filter.get('discussion_created_at_to').value == 0; else elseTemplateCompletedFilter">
                      {{ "Without date" | translate }}
                    </ng-container>
                    <ng-template #elseTemplateCompletedFilter>
                      {{ filter?.get('discussion_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    </ng-template>
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0'">
                <span class="chip_out_label">{{ "File added" | translate }}</span>

                <div class="chip_splash"></div>
                
                <ng-container *ngIf="filter.get('file_created_at_from').value">
                  <span class="small_chip_out_label">{{ "from" | translate}}</span>
                  <mat-chip (removed)="removeValue('file_created_at_from')">
                    {{ filter?.get('file_created_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
        
                <ng-container *ngIf="filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0'">
                  <span class="small_chip_out_label">{{ "to" | translate}}</span>
                  <mat-chip (removed)="removeValue('file_created_at_to')">
                    <ng-container *ngIf="filter.get('file_created_at_to').value == 0; else elseTemplateCompletedFilter">
                      {{ "Without date" | translate }}
                    </ng-container>
                    <ng-template #elseTemplateCompletedFilter>
                      {{ filter?.get('file_created_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    </ng-template>
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0'">
                <span class="chip_out_label">{{ "File updated" | translate }}</span>

                <div class="chip_splash"></div>
                
                <ng-container *ngIf="filter.get('file_updated_at_from').value">
                  <span class="small_chip_out_label">{{ "from" | translate}}</span>
                  <mat-chip (removed)="removeValue('file_updated_at_from')">
                    {{ filter?.get('file_updated_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
        
                <ng-container *ngIf="filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0'">
                  <span class="small_chip_out_label">{{ "to" | translate}}</span>
                  <mat-chip (removed)="removeValue('file_updated_at_to')">
                    <ng-container *ngIf="filter.get('file_updated_at_to').value == 0; else elseTemplateCompletedFilter">
                      {{ "Without date" | translate }}
                    </ng-container>
                    <ng-template #elseTemplateCompletedFilter>
                      {{ filter?.get('file_updated_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    </ng-template>
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0'">
                <span class="chip_out_label">{{ "File created" | translate }}</span>

                <div class="chip_splash"></div>
                
                <ng-container *ngIf="filter.get('file_meta_creation_time_from').value">
                  <span class="small_chip_out_label">{{ "from" | translate}}</span>
                  <mat-chip (removed)="removeValue('file_meta_creation_time_from')">
                    {{ filter?.get('file_meta_creation_time_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
        
                <ng-container *ngIf="filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0'">
                  <span class="small_chip_out_label">{{ "to" | translate}}</span>
                  <mat-chip (removed)="removeValue('file_meta_creation_time_to')">
                    <ng-container *ngIf="filter.get('file_meta_creation_time_to').value == 0; else elseTemplateCompletedFilter">
                      {{ "Without date" | translate }}
                    </ng-container>
                    <ng-template #elseTemplateCompletedFilter>
                      {{ filter?.get('file_meta_creation_time_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    </ng-template>
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0'">
                <span class="chip_out_label">{{ "Post published" | translate }}</span>

                <div class="chip_splash"></div>
                
                <ng-container *ngIf="filter.get('task_channel_published_at_from').value">
                  <span class="small_chip_out_label">{{ "from" | translate}}</span>
                  <mat-chip (removed)="removeValue('task_channel_published_at_from')">
                    {{ filter?.get('task_channel_published_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
        
                <ng-container *ngIf="filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0'">
                  <span class="small_chip_out_label">{{ "to" | translate}}</span>
                  <mat-chip (removed)="removeValue('task_channel_published_at_to')">
                    <ng-container *ngIf="filter.get('task_channel_published_at_to').value == 0; else elseTemplateCompletedFilter">
                      {{ "Without date" | translate }}
                    </ng-container>
                    <ng-template #elseTemplateCompletedFilter>
                      {{ filter?.get('task_channel_published_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    </ng-template>
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="filter.get('group_id').value.length">
                <span class="chip_out_label">{{ "Group" | translate }}</span>
                <mat-chip *ngFor="let id of filter.get('group_id').value" (removed)="removeValueFromMultiple('group_id', id)">
                  <ng-container *ngIf="id === 0; else elseTemplateNoGroup">
                    {{ "Goup not set" | translate }}
                  </ng-container>
                  <ng-template #elseTemplateNoGroup>
                    {{getGroup(id) ? getGroup(id)?.name : getPartnerGroup(id)?.name}}
                  </ng-template>
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
              
              <ng-container *ngIf="filter.get('start_at_from').value && filter.get('start_at_to').value && filter.get('start_at_from').value == todayStartVal && filter.get('start_at_to').value == todayEndVal; else elseTemplateTodayFilter">
                <mat-chip (removed)="removeValue('start_at_from,start_at_to', true)">
                  {{ "Today" | translate }}: {{ filter?.get('start_at_from').value | date:'MMM d. Y':'':activeLang | yearPipe }}
                  <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                </mat-chip>
              </ng-container>
              <ng-template #elseTemplateTodayFilter>
                
                <ng-container *ngIf="filter.get('start_at_from').value && filter.get('start_at_to').value && filter.get('start_at_from').value == tomorrowStartVal && filter.get('start_at_to').value == tomorrowEndVal; else elseTemplateTomorrowFilter">
                  <mat-chip (removed)="removeValue('start_at_from,start_at_to', true)">
                    {{ "Tomorrow" | translate }}: {{ filter?.get('start_at_from').value | date:'MMM d. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-container>

                <ng-template #elseTemplateTomorrowFilter>
                  <mat-chip (removed)="removeValue('start_at_from')" *ngIf="filter.get('start_at_from').value">
                    {{ filter?.get('start_at_from').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
          
                  <mat-chip (removed)="removeValue('start_at_to')" *ngIf="filter.get('start_at_to').value || filter?.get('start_at_to').value == '0'">
                    {{ filter?.get('start_at_to').value | date:'MMM dd. Y':'':activeLang | yearPipe }}
                    <mat-icon class="remove_chip_btn" matChipRemove>cancel</mat-icon>
                  </mat-chip>
                </ng-template>
                
              </ng-template>
              
              
            
    
      
              <mat-icon class="remove_all_chips_btn" (click)="removeValue('all')" *ngIf="filter.get('start_at_to').value || filter.get('group_id').value.length || filter.get('channel_id').value.length || filter.get('no_channel_id').value.length || filter.get('no_operation_id').value || filter.get('task_custom_id').value || (filter.get('origin_company_id').value && getPartner(filter.get('origin_company_id').value)) || filter.get('task_created_at_from').value || filter.get('task_created_at_to').value || filter?.get('task_created_at_to').value == '0' || filter.get('task_operation_created_at_from').value || filter.get('task_operation_created_at_to').value || filter?.get('task_operation_created_at_to').value == '0' || filter.get('task_operation_completed_at_from').value || filter.get('task_operation_completed_at_to').value || filter?.get('task_operation_completed_at_to').value == '0' || filter.get('discussion_created_at_from').value || filter.get('discussion_created_at_to').value || filter?.get('discussion_created_at_to').value == '0' || filter.get('file_created_at_from').value || filter.get('file_created_at_to').value || filter?.get('file_created_at_to').value == '0' || filter.get('file_updated_at_from').value || filter.get('file_updated_at_to').value || filter?.get('file_updated_at_to').value == '0' || filter.get('file_meta_creation_time_from').value || filter.get('file_meta_creation_time_to').value || filter?.get('file_meta_creation_time_to').value == '0' || filter.get('task_channel_published_at_from').value || filter.get('task_channel_published_at_to').value || filter?.get('task_channel_published_at_to').value == '0' || (filter.get('is_content_url').value || filter?.get('is_content_url').value == '0') || activatedRoute.snapshot.queryParamMap.get('channel_platform_id') || filter.get('task_parameter_value_id').value.length || filter.get('discussion_parameter_value_id').value.length || filter.get('task_operation_parameter_value_id').value.length || filter.get('parameter_value_id').value.length || filter.get('file_parameter_value_id').value.length || filter.get('discussion_id').value || filter.get('task_operation_operation_id').value || filter.get('operation_employee_id').value || filter.get('q').value">cancel</mat-icon>
            </mat-chip-list>
            <!-- <button mat-raised-button (click)="initRefreshBoard()">click</button> -->
             <div class="d-f-c">

               <form [formGroup]="filter" class="preset_form" *ngIf="bookmarks && bookmarks.length > 0">
                 <div class="simple_filter_snippet" (click)="presetFilter.open()">
                   <ng-container *ngIf="filter.get('preset_id').value; else elseTemplatePreset">
                     <span class="name">
                       {{ getBookmarkById(filter.get('preset_id').value)?.name }}
                     </span>
                   </ng-container>
                   <ng-template #elseTemplatePreset>
                     <span class="name">
                       {{ "Preset" | translate }}
                     </span>
                   </ng-template>
                   
   
                   <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                     <g clip-path="url(#clip0_2474_38987)">
                     <path d="M7.91699 3.33325L2.08366 3.33325L5.00033 7.91658L7.91699 3.33325Z" fill="black"/>
                     </g>
                     <defs>
                     <clipPath id="clip0_2474_38987">
                     <rect width="10" height="10" fill="white" transform="translate(10) rotate(90)"/>
                     </clipPath>
                     </defs>
                   </svg>
                 </div>
   
                 <mat-form-field appearance="legacy" class="filter_form preset_filter">
                   <mat-label>{{ "Preset" | translate }}</mat-label>
                   <mat-select #presetFilter [disableOptionCentering]="true" selectDir formControlName="preset_id" (selectionChange)="bookmarksChange($event)">
                       <mat-option *ngIf="bookmarks.length > 7">
                         <ngx-mat-select-search 
                             placeholderLabel="{{ 'Search' | translate }}" 
                             noEntriesFoundLabel="{{ 'no matching presets found' | translate }}"
                             [formControl]="bookmarksControl"></ngx-mat-select-search>
                       </mat-option>
                       <mat-option *ngFor="let bookmark of bookmarks$ | async" [value]="bookmark.id">
                         {{ bookmark.name | translate }}
                       </mat-option>
                   </mat-select>
                 </mat-form-field>
   
                </form>
                <button type="button" mat-icon-button (click)="refreshPage()" #tooltip="matTooltip"
                  matTooltip="{{ 'Refresh results on the page' | translate }}"
                  [matTooltipPosition]="'above'">
                  <mat-icon>refresh</mat-icon>
                </button>
             </div>

          </div>

          <div class="task_collections_wrp" *ngIf="boardCollection?.selected?.length && (company?.permissions?.includes('owner') || company?.permissions.includes('admin') || company?.permissions?.includes('manager'))">
            <span>{{ "Actions with selected" | translate }}</span>
            <span>{{ boardCollection?.selected?.length }}</span>
            <span>{{ "element(s):" | translate }}</span>
        
            <div class="collections_btns">
              <button type="button" (click)="multiEditStartAt()">
                {{ "Edit start at" | translate }}
              </button>
              <button type="button" *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('top', 'all', todo)">
                {{ "Move to top" | translate }}
              </button>
              <button type="button" *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('bottom', 'all', todo)">
                {{ "Move to bottom" | translate }}
              </button>
              <button type="button" *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('top', 'step', todo)">
                {{ "Move to 1 step up" | translate }}
              </button>
              <button type="button" *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('bottom', 'step', todo)">
                {{ "Move to 1 step down" | translate }}
              </button>
            </div>
          </div>

      </div>

      <div *ngIf="is_mobile && showFilter" class="mobile_tasks_title_Wrp unselectable">
        <div class="mobile_filter_line">
          <div class="d-f-c">
            <ng-container *ngIf="selectedIndex.value == 0; else elseTemplateToDoFilter">
              <button mat-raised-button [matMenuTriggerFor]="mobileStatusTab" class="mobActiveFilter">
                <ng-container [ngSwitch]="activeStatus">
                  <ng-container *ngSwitchCase="'1,2,5'">
                    {{ "All to do" | translate }} 
                  </ng-container>
                  <ng-container *ngSwitchCase="'1'">
                    {{ "Waiting" | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'2'">
                    {{ "In process" | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'5'">
                    {{ "To correct" | translate }}
                  </ng-container>
                </ng-container>
              </button>
              <mat-menu #mobileStatusTab="matMenu" class="mobileStatus" xPosition='after' [overlayPanelClass]='mobileStatusTab'>
                <button mat-menu-item (click)='changeActiveStatus(0)' [ngClass]="{'active_status': activeStatus.sort().toString() == '1,2,5'}">{{ "All To Do" | translate }}</button>
                <button mat-menu-item (click)='changeActiveStatus(1)' [ngClass]="{'active_status': activeStatus.includes(1) && activeStatus.length == 1}">{{ "Waiting" | translate }}</button>
                <button mat-menu-item (click)='changeActiveStatus(2)' [ngClass]="{'active_status': activeStatus.includes(2)} && activeStatus.length == 1">{{ "In process" | translate }}</button>
                <button mat-menu-item (click)='changeActiveStatus(5)' [ngClass]="{'active_status': activeStatus.includes(5)} && activeStatus.length == 1">{{ "To correct" | translate }}</button>
              </mat-menu>
            </ng-container>
            <ng-template #elseTemplateToDoFilter>
              <button mat-raised-button [matMenuTriggerFor]="mobileStatusTabToDo" class="mobActiveFilter">
                <ng-container [ngSwitch]="doneStatus">
                  <ng-container *ngSwitchCase="'3,4,6,97,98,99'">
                    {{ "All Done" | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'3'">
                    {{ "To approve" | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'4'">
                    {{ "Approved" | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'6'">
                    {{ "Sources needed" | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'97'">
                    {{ "On hold" | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'98'">
                    {{ "Ready" | translate }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'99'">
                    {{ "Canceled" | translate }}
                  </ng-container>
                </ng-container>
              </button>
              <mat-menu #mobileStatusTabToDo="matMenu" class="mobileStatus" xPosition='after' [overlayPanelClass]='mobileStatusTab'>
                <button mat-menu-item  (click)='changeDoneStatus(0)' [ngClass]="{'active_status': doneStatus.sort().toString() == '3,4,6,97,98,99'}">{{ "All Done" | translate }}</button>
                <button mat-menu-item  (click)='changeDoneStatus(3)' [ngClass]="{'active_status': doneStatus.includes(3) && activeStatus.length == 1}">{{ "To approve" | translate }}</button>
                <button mat-menu-item  (click)='changeDoneStatus(4)' [ngClass]="{'active_status': doneStatus.includes(4) && activeStatus.length == 1}">{{ "Approved" | translate }}</button>
                <button mat-menu-item  (click)='changeDoneStatus(6)' [ngClass]="{'active_status': doneStatus.includes(6) && activeStatus.length == 1}">{{ "Sources needed" | translate }}</button>
                <button mat-menu-item  (click)='changeDoneStatus(97)' [ngClass]="{'active_status': doneStatus.includes(97) && activeStatus.length == 1}">{{ "On hold" | translate }}</button>
                <button mat-menu-item  (click)='changeDoneStatus(98)' [ngClass]="{'active_status': doneStatus.includes(98) && activeStatus.length == 1}">{{ "Ready" | translate }}</button>
                <button mat-menu-item  (click)='changeDoneStatus(99)' [ngClass]="{'active_status': doneStatus.includes(99) && activeStatus.length == 1}">{{ "Canceled" | translate }}</button>
              </mat-menu>
            </ng-template>
            

            <button style="padding: 0 6px !important; min-width: auto !important;" class="ml-1" mat-raised-button (click)='openMobFilter()'>
              <mat-icon>filter_list</mat-icon>
            </button>
            <!-- <button class="ml-1" style="min-width: auto !important; padding: 0 6px !important;" *ngIf="boardCollection?.selected?.length" (click)="addMultiWorks()" mat-raised-button color="warn">
              <mat-icon>add</mat-icon>{{boardCollection?.selected?.length}}
            </button> -->
            <button [matMenuTriggerFor]="multiMenu" style="min-width: auto !important; padding: 0 6px !important;" class="ml-1" *ngIf="boardCollection?.selected?.length && (company?.permissions?.includes('owner') || company?.permissions.includes('admin') || company?.permissions?.includes('manager'))" mat-raised-button color="warn">
              {{boardCollection?.selected?.length}}
              <mat-icon>settings</mat-icon>
            </button>
            <mat-menu #multiMenu="matMenu" xPosition="after">
              <button (click)="multiEditStartAt()" mat-menu-item>
                <mat-icon>schedule</mat-icon>
                {{ "Edit start at" | translate }}
              </button>
              <button mat-menu-item *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('top', 'all', todo)">
                <mat-icon>vertical_align_top</mat-icon>
                {{ "Move to top" | translate }}
              </button>
              <button mat-menu-item *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('bottom', 'all', todo)">
                <mat-icon>vertical_align_bottom</mat-icon>
                {{ "Move to bottom" | translate }}
              </button>
              <button mat-menu-item *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('top', 'step', todo)">
                <mat-icon>plus_one</mat-icon>
                {{ "Move to 1 step up" | translate }}
              </button>
              <button mat-menu-item *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('bottom', 'step', todo)">
                <mat-icon>exposure_neg_1</mat-icon>
                {{ "Move to 1 step down" | translate }}
              </button>
            </mat-menu>
            <button style="padding: 0 6px !important; min-width: auto !important;" class="ml-1" mat-raised-button (click)="goToPlaningBoard($event)">
              <svg style="width: 20px; height: 15px;" width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 15H20V13H12V15ZM12 9.5H20V7.5H12V9.5ZM12 4H20V2H12V4ZM0 8.5C0 4.92 2.92 2 6.5 2H7V0L10 3L7 6V4H6.5C4 4 2 6 2 8.5C2 11 4 13 6.5 13H10V15H6.5C2.92 15 0 12.08 0 8.5Z" fill="#686868"/>
              </svg>
            </button>
          </div>
          <mat-form-field [style.width]="boardCollection?.selected?.length ? '150px' : 'initial'" class="mobile_search">
            <input matInput #mobileSearch type="search" [value]="filter.get('q').value" placeholder="{{ 'Search' | translate}}" class="search-input">
            <mat-icon (click)="searchInMobile(mobileSearch)" matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
        <div class="mobile_filter_wrp" #mobile_filter_wrp>
          <div class="d-f-c" style="justify-content: space-between;">
            <div class="d-f-c" style="display: inline-flex;">
              <button mat-button type="button" (click)="closeMobFilter(); filterReset()">{{ "Reset" | translate }}</button>
              <button mat-raised-button type="button" class="ml-1" color="primary" (click)="closeMobFilter(); filterData()">{{ "Filter" | translate }}</button>
            </div>
            <button mat-raised-button (click)='closeMobFilter()'>
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <form [formGroup]="filter" class="filter_wrp">
            <div class="mob_filter_inputs_wrp">
              <div class="d-f-c">
                <mat-form-field appearance="standard" class="filter_form search">
                  <!-- <mat-label>{{ 'Search' | translate }}</mat-label> -->
                  <mat-icon matPrefix>search</mat-icon>
                  <input formControlName="q" matInput>
                  <mat-icon (click)="$event.stopPropagation();" matSuffix>tune</mat-icon>
                </mat-form-field>
              </div>

          
              <mat-form-field appearance="standard" class="filter_form executor">
                <mat-label>{{ "Executor" | translate }}</mat-label>
                <mat-select [disableOptionCentering]="true" selectDir formControlName="operation_employee_id"  (selectionChange)="selectChange($event)">
                  <mat-option>
                    <ngx-mat-select-search 
                        placeholderLabel="{{ 'Search' | translate }}" 
                        noEntriesFoundLabel="{{ 'no matching member found' | translate }}"
                        [formControl]="execControl"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                    <app-user [class]="'user_div'" [employee]="employee"></app-user>
                  </mat-option>
                </mat-select>
              </mat-form-field>
          
              <mat-form-field appearance="standard" class="example-form-field filter_form date">
                <mat-label>{{ 'Date' | translate }}</mat-label>
                <mat-date-range-input  [rangePicker]="rangePicker">
                    <input formControlName="start_at_from" matStartDate placeholder="{{ 'Date from' | translate }}">
                    <input formControlName="start_at_to" matEndDate placeholder="{{ 'Date to' | translate }}">
                </mat-date-range-input>
                <mat-datepicker-toggle matPrefix [for]="rangePicker"></mat-datepicker-toggle>
                <mat-date-range-picker #rangePicker>
                  <mat-date-range-picker-actions>
                    <button mat-button matDateRangePickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" (click)="filterData()" matDateRangePickerApply>Apply</button>
                  </mat-date-range-picker-actions>
                </mat-date-range-picker>
              </mat-form-field>
            </div>
          </form>
        </div>
      </div>
    </div>


    
      <ng-container *ngIf="!is_mobile; else elseTemplateDesktopPage">
        <div class="container board_out">
          <div cdkDropListGroup class="board_wrp">
            <div class="todos_wrp">
                <div class="lists_wrp" *ngIf="!is_mobile">
                  <div class="lists_left">
                      <div class="check_wrp">
                        <mat-checkbox class="select_all_checkbox" *ngIf="boardCollection" (click)="$event.preventDefault; $event.stopPropagation()" (change)="$event ? masterTodoToggle() : null"
                          [checked]="hasTodoValue() && isAllTodoSelected()"
                          [indeterminate]="hasTodoValue() && !isAllTodoSelected()"
                          [aria-label]="checkboxTodoLabel()">
                        </mat-checkbox>
                      </div>
                        <div class="job_status_wrp">
                            <button mat-button (click)='changeActiveStatus(0, $event)' [ngClass]="{'active_status': activeStatus.includes(1) && activeStatus.includes(2) && activeStatus.includes(5)}">{{ "All To Do" | translate }}</button>
                            <button mat-button (click)='changeActiveStatus(1, $event)' [ngClass]="{'active_status': activeStatus.includes(1) && activeStatus.length == 1}">{{ "Waiting" | translate }}</button>
                            <button mat-button (click)='changeActiveStatus(2, $event)' [ngClass]="{'active_status': activeStatus.includes(2) && activeStatus.length == 1}">{{ "In process" | translate }}</button>
                            <button mat-button (click)='changeActiveStatus(5, $event)' [ngClass]="{'active_status': activeStatus.includes(5) && activeStatus.length == 1}">{{ "To correct" | translate }}</button>
                        </div>
                    </div>
              
                   
                    <div class="d-f-c">
                      <mat-button-toggle-group class="view_group" (change)="changeDay($event)" [value]="filter.get('start_at_from').value == todayStartVal && (filter.get('start_at_to').value == todayEndVal || filter.get('start_at_to').value == todayEndVal + 1) ? 'today' : filter.get('start_at_from').value == tomorrowStartVal && (filter.get('start_at_to').value == tomorrowEndVal || filter.get('start_at_to').value == tomorrowEndVal + 1) ? 'tomorow' : ''">
                          <mat-button-toggle value="today">{{ "Today" | translate }}</mat-button-toggle>
                          <mat-button-toggle value="tomorow">{{ "Tomorrow" | translate }}</mat-button-toggle>
                      </mat-button-toggle-group>
                    </div>
                  
                </div>
                <div
                    #todoContainer
                    cdkDropList
                    [cdkDropListData]="todo"
                    [id]="'todo'"
                    class="reports-list"
                    (cdkDropListDropped)="drop($event)">
                    <div class="board_item" (contextmenu)="openCardContext($event, item); $event.preventDefault(); $event.stopPropagation();" (click)="item.discussion_id ? openChat($event, item, i, todo) : openJob($event, item, i, todo)" *ngFor="let item of todo; let i = index;" (cdkDragStarted)="startDrag($event)" (cdkDragEnded)="endDrag($event)" [cdkDragData]="item" cdkDrag [ngClass]="{'has_clients': item?.clients?.length > 0, 'no_clients': item?.clients?.length == 0 || !item?.clients}">
                      
                      <mat-progress-bar mode="indeterminate" *ngIf="item.isLoad" class="mat_proggress_w8 job_proggress"></mat-progress-bar>
                      <div class="board_btns" [ngClass]="{'show': is_mobile || boardCollection.isSelected(item)}">
                        <div class="check_wrp">
                          <mat-checkbox color="primary" class="example-margin" (click)="clickOnCheck($event, item, i, todo); $event.stopPropagation()" (change)="$event ? toggleItem(item) : null" [checked]='boardCollection.isSelected(item)'></mat-checkbox>
                        </div>
                      </div>
    
                        <div class="board_info">
                          <div class="dates">
                            <div class="left">
                              <div class="status_id">
                                <span>{{item.id}}</span>
                                <span>
                                  {{ getTaskStatusById(item?.task?.status_id)?.name }}
                                </span>
                              </div>
                              <div class="start_at_date"
                              [ngClass]="{'time_of': item.initial_start_at < today}"
                              #tooltip="matTooltip"
                              matTooltip="{{ item.initial_start_at*1000 | date:'MMM dd. Y, hh:mm a':'':activeLang }}"
                              [matTooltipPosition]="'below'">{{ item.start_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                              <div class="start_at_time">
                                {{ item.start_at*1000 | date:'hh:mm a':'':activeLang | yearPipe }}
                              </div>
                            </div>
                            <div class="right">
                              <div>{{ item.created_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                              <div>{{ item.updated_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                            </div>
    
                          </div>
    
                          <div class="bottom_info">
                            <div class="empl_line">
                              <div class="inside_job" [ngClass]="{
                                'first': item?.status_id == '1',
                                'second': item?.status_id == '2',
                                'third': item?.status_id == '3',
                                'fours': item?.status_id == '4',
                                'fives': item?.status_id == '5',
                                'sixs': item?.status_id == '6',
                                'nine': item?.status_id == '97',
                                'seven': item?.status_id == '98',
                                'eight': item?.status_id == '99'}">
                                <span>{{ (getOperationStatusName(item?.status_id) | translate).length > 15 ? ((getOperationStatusName(item?.status_id) | translate) | slice:0:12) + "..." : (getOperationStatusName(item?.status_id) | translate) }}</span>  
                              </div>
                              <div class="employees">
                                <div class="employee">
                                  <ng-container *ngIf="item?.is_partner; else elsePartner">
                                    <ng-container *ngIf="!!item?.partnerCompany?.avatarFile?.thumbnail && !!host; else elseTemplatePartnerAvatar">
                                        <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" class="partner_avatar" (error)="onPartnerImgError($event)" [src]="host + item?.partnerCompany?.avatarFile?.thumbnail + '?company_id=' + company?.id" alt="">
                                    </ng-container>
                                    <ng-template #elseTemplatePartnerAvatar>
                                        <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" class="partner_avatar" (error)="onPartnerImgError($event)" src="{{ imgRoute }}assets/img/partner.png" alt="">
                                    </ng-template>
                                  </ng-container>
                                  <ng-template #elsePartner>
                                    <ng-container *ngIf="item?.employee?.image; else elseTemplatePhoto">
                                      <img [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }" [src]="item?.employee?.image">
                                    </ng-container>
                                    <ng-template #elseTemplatePhoto>
                                        <mat-icon [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }">account_circle</mat-icon>
                                    </ng-template>
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                            <div class="icons_line">
                              <div class="icons_wrp">
                                <ng-container *ngIf="item.discussion_id; else elseTemplateDisc">
                                  <div class="chat">
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill="#6299E1" d="M24.6875 0.6875C25.3958 0.6875 26 0.958333 26.5 1.5C27.0417 2 27.3125 2.60417 27.3125 3.3125V19.3125C27.3125 20.0208 27.0417 20.6458 26.5 21.1875C26 21.7292 25.3958 22 24.6875 22H6L0.6875 27.3125V3.3125C0.6875 2.60417 0.9375 2 1.4375 1.5C1.97917 0.958333 2.60417 0.6875 3.3125 0.6875H24.6875Z"/>
                                    </svg>
                                    <div class="red_point" *ngIf="item?.unReadChats"></div>
                                  </div>
                                  <div class="to_files">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.5 9.375C1.5 7.095 3.345 5.25 5.625 5.25H13.5C15.1575 5.25 16.5 6.5925 16.5 8.25C16.5 9.9075 15.1575 11.25 13.5 11.25H7.125C6.09 11.25 5.25 10.41 5.25 9.375C5.25 8.34 6.09 7.5 7.125 7.5H12.75V9H7.0575C6.645 9 6.645 9.75 7.0575 9.75H13.5C14.325 9.75 15 9.075 15 8.25C15 7.425 14.325 6.75 13.5 6.75H5.625C4.1775 6.75 3 7.9275 3 9.375C3 10.8225 4.1775 12 5.625 12H12.75V13.5H5.625C3.345 13.5 1.5 11.655 1.5 9.375Z" fill="#1877F2"/>
                                    </svg>
                                    <ng-container *ngIf="item?.discussion?.filesize">
                                      <div class="filesize" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{item?.discussion?.file_stat_updated_at > 0 ? (item?.discussion?.file_stat_updated_at*1000 | date:'hh:mm a, MMM d, y':'':activeLang | yearPipe) : ''}}">
                                        {{ item?.discussion?.filesize | filesize }}
                                      </div>
                                    </ng-container>
                                  </div>
                                </ng-container>
                                <ng-template #elseTemplateDisc>
                                  <div class="chat" style="visibility: hidden;" (click)="goToChats(item)">
                                    <span class="c_v">{{item?.chatsCount}}</span>
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill="#6299E1" d="M24.6875 0.6875C25.3958 0.6875 26 0.958333 26.5 1.5C27.0417 2 27.3125 2.60417 27.3125 3.3125V19.3125C27.3125 20.0208 27.0417 20.6458 26.5 21.1875C26 21.7292 25.3958 22 24.6875 22H6L0.6875 27.3125V3.3125C0.6875 2.60417 0.9375 2 1.4375 1.5C1.97917 0.958333 2.60417 0.6875 3.3125 0.6875H24.6875Z"/>
                                    </svg>
                                    <div class="red_point" *ngIf="item?.unReadChats"></div>
                                  </div>
                                  <div class="to_files">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.5 9.375C1.5 7.095 3.345 5.25 5.625 5.25H13.5C15.1575 5.25 16.5 6.5925 16.5 8.25C16.5 9.9075 15.1575 11.25 13.5 11.25H7.125C6.09 11.25 5.25 10.41 5.25 9.375C5.25 8.34 6.09 7.5 7.125 7.5H12.75V9H7.0575C6.645 9 6.645 9.75 7.0575 9.75H13.5C14.325 9.75 15 9.075 15 8.25C15 7.425 14.325 6.75 13.5 6.75H5.625C4.1775 6.75 3 7.9275 3 9.375C3 10.8225 4.1775 12 5.625 12H12.75V13.5H5.625C3.345 13.5 1.5 11.655 1.5 9.375Z" fill="#1877F2"/>
                                    </svg>
                                    <ng-container *ngIf="item?.taskOperation?.filesize">
                                      <div class="filesize" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ item?.taskOperation?.file_stat_updated_at > 0 ? (item?.taskOperation?.file_stat_updated_at*1000 | date:'hh:mm a, MMM d, y':'':activeLang | yearPipe) : '' }}">
                                        {{ item?.taskOperation?.filesize | filesize }}
                                      </div>
                                    </ng-container>
                                  </div>
                                </ng-template>
                                
    
                              </div>
                              <div class="status_type">
                                <ng-container *ngIf="item.discussion_id; else elseTemplateType">
                                  {{ "Chat" | translate }}
                                </ng-container>
                                <ng-template #elseTemplateType>
                                  {{ "Work" | translate }}
                                </ng-template>
                              </div>
                            </div>
                          </div>
    
                        </div>
                        <div class="board_names">
                          <div class="job_type_line">
                            <span class="text_one_line">{{getColumnName(item?.taskOperation.operation_id)}}</span>
                            <span class="text_one_line" *ngIf="!!item?.discussion_id">{{item?.taskOperation?.name}}</span>
                            <span class="text_one_line">
                              <ng-container *ngIf="item?.task?.group?.name; else elseTemplateNBSP">
                                {{item?.task?.group?.name}}
                              </ng-container>
                            </span>
                          </div>
                          <div class="type_name text_one_line">
                            <ng-container *ngIf="item?.discussion_id; else elseTemplateItIsDiscussion">
                              {{ item?.discussion?.name}}
                            </ng-container>
                            <ng-template #elseTemplateItIsDiscussion>
                              <ng-container *ngIf="item?.taskOperation?.name; else elseTemplateNBSP">
                                {{ item?.taskOperation?.name }}
                              </ng-container>
                            </ng-template>
                          </div>
                          <div class="type_comment">
                            <ng-container *ngIf="item?.discussion_id; else elseTemplateItIsDisc">
                              <ng-container *ngIf="item?.discussion?.lastPost?.action; else elseTemplateHasAction">
                                <div class="chat_last_post">
          
                                  <ng-container *ngIf="!!item?.discussion?.lastPost?.action?.createdEmployee?.image; else elseOwnerTemplateLastPost">
                                      <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5" [src]="item?.discussion?.lastPost?.action?.createdEmployee?.image" alt="">
                                  </ng-container>
                                  <ng-template #elseOwnerTemplateLastPost>
                                      <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5">account_circle</mat-icon>
                                  </ng-template>
          
                                  {{ 'switched to' | translate }} 
                                  <ng-container [ngSwitch]="item?.discussion?.lastPost?.action?.action">
                                    <ng-container *ngSwitchCase="'task_employee_status_change'">
                                      <b style="margin-left: 5px; margin-right: 5px;">{{ getOperationStatusName(item?.discussion?.lastPost?.action?.task_employee_status_id) }}</b>
                                      {{ "for" | translate }}
                                      <ng-container *ngIf="!!item?.discussion?.lastPost?.action?.employee?.image; else elseActionOwnerTemplate">
                                          <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5" [src]="item?.discussion?.lastPost?.action?.employee?.image" alt="">
                                      </ng-container>
                                      <ng-template #elseActionOwnerTemplate>
                                          <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5">account_circle</mat-icon>
                                      </ng-template>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'discussion_status'">
                                       <b style="margin-left: 5px;">{{ getOperationStatusName(item?.discussion?.lastPost?.action?.discussion_status_id) }}</b>
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </ng-container>
          
                              <ng-template #elseTemplateHasAction>
                                <div class="chat_last_post">
                                  <ng-container *ngIf="!!item?.discussion?.lastPost?.employee?.image; else elseOwnerTemplateLastPost">
                                      <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.employee, company_id: company?.id }" [src]="item?.discussion?.lastPost?.employee?.image" alt="">
                                  </ng-container>
                                  <ng-template #elseOwnerTemplateLastPost>
                                      <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.employee, company_id: company?.id }">account_circle</mat-icon>
                                  </ng-template>
                                  
                                  <div class="last_post_file" *ngIf="!!item?.discussion?.lastPost?.file_id">
                                    <div class="file_view">
                                      <ng-container [ngSwitch]="understandFileType(item?.discussion?.lastPost?.file?.content_type)">
                                          <ng-container *ngSwitchCase="'video'">
                                              <div class="file movie d-f-c">
                                                  <ng-container *ngIf="item?.discussion?.lastPost?.file?.thumbnail; else elseTemplateThumbnail">
                                                      <div class="movie_thumb" >
                                                          <img style="max-width: 100%; max-height: 100%;" (error)="onImgError($event)" [src]="host + item?.discussion?.lastPost?.file?.thumbnail">
                                                      </div>
                                                  </ng-container>
                                                  <ng-template #elseTemplateThumbnail>
                                                      <mat-icon class="file_img_icon" style="color: #3f51b5">
                                                          movie
                                                      </mat-icon>
                                                  </ng-template>
                                              </div>
                                          </ng-container>
                                          <ng-container *ngSwitchCase="'pdf'">
                                            <div class="pdf">
                                                <svg height="800px" width="800px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                                    viewBox="0 0 303.188 303.188" xml:space="preserve">
                                                    <g>
                                                        <polygon style="fill:#E8E8E8;" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 	"/>
                                                        <path style="fill:#FB3449;" d="M230.013,149.935c-3.643-6.493-16.231-8.533-22.006-9.451c-4.552-0.724-9.199-0.94-13.803-0.936
                                                            c-3.615-0.024-7.177,0.154-10.693,0.354c-1.296,0.087-2.579,0.199-3.861,0.31c-1.314-1.36-2.584-2.765-3.813-4.202
                                                            c-7.82-9.257-14.134-19.755-19.279-30.664c1.366-5.271,2.459-10.772,3.119-16.485c1.205-10.427,1.619-22.31-2.288-32.251
                                                            c-1.349-3.431-4.946-7.608-9.096-5.528c-4.771,2.392-6.113,9.169-6.502,13.973c-0.313,3.883-0.094,7.776,0.558,11.594
                                                            c0.664,3.844,1.733,7.494,2.897,11.139c1.086,3.342,2.283,6.658,3.588,9.943c-0.828,2.586-1.707,5.127-2.63,7.603
                                                            c-2.152,5.643-4.479,11.004-6.717,16.161c-1.18,2.557-2.335,5.06-3.465,7.507c-3.576,7.855-7.458,15.566-11.815,23.02
                                                            c-10.163,3.585-19.283,7.741-26.857,12.625c-4.063,2.625-7.652,5.476-10.641,8.603c-2.822,2.952-5.69,6.783-5.941,11.024
                                                            c-0.141,2.394,0.807,4.717,2.768,6.137c2.697,2.015,6.271,1.881,9.4,1.225c10.25-2.15,18.121-10.961,24.824-18.387
                                                            c4.617-5.115,9.872-11.61,15.369-19.465c0.012-0.018,0.024-0.036,0.037-0.054c9.428-2.923,19.689-5.391,30.579-7.205
                                                            c4.975-0.825,10.082-1.5,15.291-1.974c3.663,3.431,7.621,6.555,11.939,9.164c3.363,2.069,6.94,3.816,10.684,5.119
                                                            c3.786,1.237,7.595,2.247,11.528,2.886c1.986,0.284,4.017,0.413,6.092,0.335c4.631-0.175,11.278-1.951,11.714-7.57
                                                            C231.127,152.765,230.756,151.257,230.013,149.935z M119.144,160.245c-2.169,3.36-4.261,6.382-6.232,9.041
                                                            c-4.827,6.568-10.34,14.369-18.322,17.286c-1.516,0.554-3.512,1.126-5.616,1.002c-1.874-0.11-3.722-0.937-3.637-3.065
                                                            c0.042-1.114,0.587-2.535,1.423-3.931c0.915-1.531,2.048-2.935,3.275-4.226c2.629-2.762,5.953-5.439,9.777-7.918
                                                            c5.865-3.805,12.867-7.23,20.672-10.286C120.035,158.858,119.587,159.564,119.144,160.245z M146.366,75.985
                                                            c-0.602-3.514-0.693-7.077-0.323-10.503c0.184-1.713,0.533-3.385,1.038-4.952c0.428-1.33,1.352-4.576,2.826-4.993
                                                            c2.43-0.688,3.177,4.529,3.452,6.005c1.566,8.396,0.186,17.733-1.693,25.969c-0.299,1.31-0.632,2.599-0.973,3.883
                                                            c-0.582-1.601-1.137-3.207-1.648-4.821C147.945,83.048,146.939,79.482,146.366,75.985z M163.049,142.265
                                                            c-9.13,1.48-17.815,3.419-25.979,5.708c0.983-0.275,5.475-8.788,6.477-10.555c4.721-8.315,8.583-17.042,11.358-26.197
                                                            c4.9,9.691,10.847,18.962,18.153,27.214c0.673,0.749,1.357,1.489,2.053,2.22C171.017,141.096,166.988,141.633,163.049,142.265z
                                                            M224.793,153.959c-0.334,1.805-4.189,2.837-5.988,3.121c-5.316,0.836-10.94,0.167-16.028-1.542
                                                            c-3.491-1.172-6.858-2.768-10.057-4.688c-3.18-1.921-6.155-4.181-8.936-6.673c3.429-0.206,6.9-0.341,10.388-0.275
                                                            c3.488,0.035,7.003,0.211,10.475,0.664c6.511,0.726,13.807,2.961,18.932,7.186C224.588,152.585,224.91,153.321,224.793,153.959z"/>
                                                        <polygon style="fill:#FB3449;" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0 	"/>
                                                        <g>
                                                            <path style="fill:#A4A9AD;" d="M126.841,241.152c0,5.361-1.58,9.501-4.742,12.421c-3.162,2.921-7.652,4.381-13.472,4.381h-3.643
                                                                v15.917H92.022v-47.979h16.606c6.06,0,10.611,1.324,13.652,3.971C125.321,232.51,126.841,236.273,126.841,241.152z
                                                                M104.985,247.387h2.363c1.947,0,3.495-0.546,4.644-1.641c1.149-1.094,1.723-2.604,1.723-4.529c0-3.238-1.794-4.857-5.382-4.857
                                                                h-3.348C104.985,236.36,104.985,247.387,104.985,247.387z"/>
                                                            <path style="fill:#A4A9AD;" d="M175.215,248.864c0,8.007-2.205,14.177-6.613,18.509s-10.606,6.498-18.591,6.498h-15.523v-47.979
                                                                h16.606c7.701,0,13.646,1.969,17.836,5.907C173.119,235.737,175.215,241.426,175.215,248.864z M161.76,249.324
                                                                c0-4.398-0.87-7.657-2.609-9.78c-1.739-2.122-4.381-3.183-7.926-3.183h-3.773v26.877h2.888c3.939,0,6.826-1.143,8.664-3.43
                                                                C160.841,257.523,161.76,254.028,161.76,249.324z"/>
                                                            <path style="fill:#A4A9AD;" d="M196.579,273.871h-12.766v-47.979h28.355v10.403h-15.589v9.156h14.374v10.403h-14.374
                                                                L196.579,273.871L196.579,273.871z"/>
                                                        </g>
                                                        <polygon style="fill:#D1D3D3;" points="219.821,50.525 270.346,50.525 219.821,0 	"/>
                                                    </g>
                                                </svg>
                                            </div>
                                        </ng-container>
                                          <ng-container *ngSwitchCase="'image'">
                                              <div class="img_wrp">
                                                  <img (error)="onImgError($event)" [src]="host + (item?.discussion?.lastPost?.file?.thumbnail ? (item?.discussion?.lastPost?.file?.thumbnail + '?company_id=' + company?.id) : (item?.discussion?.lastPost?.file?.original + '?company_id=' + company?.id))" alt="">
                                              </div>
                                          </ng-container>
                                          <ng-container *ngSwitchDefault>
                                            <ng-container *ngIf="!!item?.discussion?.lastPost?.file?.thumbnail; else elseTemplateHasThumb">
                                              <div class="img_wrp">
                                                <img (error)="onImgError($event)" [src]="host + item?.discussion?.lastPost?.file?.thumbnail + '?company_id=' + company?.id" alt="">
                                              </div>
                                            </ng-container>
                                            <ng-template #elseTemplateHasThumb>
                                              <div class="file d-f-c">
                                                <mat-icon class="file_img_icon mr-1" style="color: #3f51b5">
                                                    insert_drive_file
                                                </mat-icon>
                                            </div>
                                            </ng-template>
                                          </ng-container>
                                      </ng-container>
                                    </div>
                                    <!-- <div class="file_info">
                                        <span class="file_name">{{ chat?.lastPost?.file?.filename }}</span>
                                        <span class="file_size">{{ chat?.lastPost?.file?.filesize | filesize }}</span>
                                    </div> -->
          
                                  </div>
                                  
                                  <!-- <div class="text_one_line">
                                    {{ item?.discussion?.lastPost?.text }}
                                  </div> -->
                                  <div class="text_one_line" [innerHTML]='item?.discussion?.lastPost?.text ? (item?.discussion?.lastPost?.text.replaceAll("\n"," ").replaceAll("</BR>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("<br>"," ")) : ""'></div>
                              </div>
                              </ng-template>
                            </ng-container>
                            <ng-template #elseTemplateItIsDisc>
                              <div class="empl_comment">
                                <ng-container *ngIf="item?.taskOperation?.employee_comment; else elseTemplateNBSP">
                                  {{item?.taskOperation?.employee_comment}}
                                </ng-container>
                              </div>
                            </ng-template>
                            
    
                          </div>
                          <div class="task_name_wrp">
                            <div class="task_name text_one_line">
                              {{item?.task?.name}}
                            </div>
                            <div class="task_ids">
                              <div>{{item?.task?.internal_id}}</div>
                              <div>{{item?.task?.id}}</div>
                            </div>
                          </div>
                        </div>
                        <div class="clients" *ngIf="item?.clients?.length > 0">
                          <div class="clients_title">
                            {{ "Clients" | translate }}:
                          </div>
                          <ng-container *ngFor="let client of item?.clients; let ind = index;">
                            <ng-container *ngIf="ind <= 2">
                              <app-user [class]="'client'" [employee]="client?.client"></app-user>
                            </ng-container>
                            
                            <div class="clients_more" *ngIf="ind == item?.clients?.length - 1 && ind > 2">
                              +{{ item?.clients?.length - 3}}
                            </div>
                          </ng-container>
    
                        </div>
                        <div class="hover_drag" (click)="$event.stopPropagation()" cdkDragHandle>
                          <div>
                            <span></span>
                            <span></span>
                            <span></span>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
          
            <div class="dones_wrp">
                <div class="lists_wrp" *ngIf="!is_mobile">
                  <div class="lists_left">
                    <div class="check_wrp">
                      <mat-checkbox class="select_all_checkbox" *ngIf="boardCollection" (click)="$event.preventDefault; $event.stopPropagation()" (change)="$event ? masterDoneToggle() : null"
                        [checked]="hasDoneValue() && isAllDoneSelected()"
                        [indeterminate]="hasDoneValue() && !isAllDoneSelected()"
                        [aria-label]="checkboxDoneLabel()">
                      </mat-checkbox>
                    </div>
        
                    <div class="job_status_wrp">
                      <button mat-button (click)='changeDoneStatus(0, $event)' [ngClass]="{'active_status': doneStatus.includes(3) && doneStatus.includes(4) && doneStatus.includes(6) && doneStatus.includes(98) && doneStatus.includes(99)}">{{ "All done" | translate }}</button>
                      <button mat-button (click)='changeDoneStatus(3, $event)' [ngClass]="{'active_status': doneStatus.includes(3) && doneStatus.length == 1}">{{ "To approve" | translate }}</button>
                      <button mat-button (click)='changeDoneStatus(4, $event)' [ngClass]="{'active_status': doneStatus.includes(4) && doneStatus.length == 1}">{{ "Approved" | translate }}</button>
                      <button mat-button (click)='changeDoneStatus(6, $event)' [ngClass]="{'active_status': doneStatus.includes(6) && doneStatus.length == 1}">{{ "Sources needed" | translate }}</button>
                      <button mat-button (click)='changeDoneStatus(97, $event)' [ngClass]="{'active_status': doneStatus.includes(97) && doneStatus.length == 1}">{{ "On hold" | translate }}</button>
                      <button mat-button (click)='changeDoneStatus(98, $event)' [ngClass]="{'active_status': doneStatus.includes(98) && doneStatus.length == 1}">{{ "Ready" | translate }}</button>
                      <button mat-button (click)='changeDoneStatus(99, $event)' [ngClass]="{'active_status': doneStatus.includes(99) && doneStatus.length == 1}">{{ "Canceled" | translate }}</button>
                    </div>
                  </div>
                  
                </div>
              <div
                #doneContainer
                cdkDropList
                [cdkDropListData]="done"
                [id]="'done'"
                class="reports-list"
                (cdkDropListDropped)="drop($event)">
                <div class="board_item" (contextmenu)="openCardContext($event, item); $event.preventDefault(); $event.stopPropagation();" (click)="item.discussion_id ? openChat($event, item, i, done) : openJob($event, item, i, done)" *ngFor="let item of done; let i = index;" [cdkDragData]="item" cdkDrag [ngClass]="{'has_clients': item?.clients?.length > 0, 'no_clients': item?.clients?.length == 0 || !item?.clients}">
                  
                  <mat-progress-bar mode="indeterminate" *ngIf="item.isLoad" class="mat_proggress_w8 job_proggress"></mat-progress-bar>
                  <div class="board_btns" [ngClass]="{'show': is_mobile || boardCollection.isSelected(item)}">
                    <div class="check_wrp">
                      <mat-checkbox color="primary" class="example-margin" (click)="clickOnCheck($event, item, i, done); $event.stopPropagation()" (change)="$event ? toggleItem(item) : null" [checked]='boardCollection.isSelected(item)'></mat-checkbox>
                    </div>
                  </div>
                  <div class="board_info">
    
                    <div class="dates">
                      <div class="left">
                        <div class="status_id">
                          <span>{{item.id}}</span>
                          <span>
                            {{ getTaskStatusById(item?.task?.status_id)?.name }}
                          </span>
                        </div>
                        <div class="start_at_date"
                        [ngClass]="{'time_of': item.initial_start_at < today}"
                        #tooltip="matTooltip"
                        matTooltip="{{ item.initial_start_at*1000 | date:'MMM dd. Y, hh:mm a':'':activeLang }}"
                        [matTooltipPosition]="'below'">{{ item.start_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                        <div class="start_at_time">
                          {{ item.start_at*1000 | date:'hh:mm a':'':activeLang | yearPipe }}
                        </div>
                      </div>
                      <div class="right">
                        <div>{{ item.created_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                        <div>{{ item.updated_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                      </div>
    
                    </div>
    
                    <div class="bottom_info">
                      <div class="empl_line">
                        <div class="inside_job" [ngClass]="{
                          'first': item?.status_id == '1',
                          'second': item?.status_id == '2',
                          'third': item?.status_id == '3',
                          'fours': item?.status_id == '4',
                          'fives': item?.status_id == '5',
                          'sixs': item?.status_id == '6',
                          'nine': item?.status_id == '97',
                          'seven': item?.status_id == '98',
                          'eight': item?.status_id == '99'}">
                          <span>{{ (getOperationStatusName(item?.status_id) | translate).length > 15 ? ((getOperationStatusName(item?.status_id) | translate) | slice:0:12) + "..." : (getOperationStatusName(item?.status_id) | translate) }}</span>  
                        </div>
                        <div class="employees">
                          <div class="employee">
                            <ng-container *ngIf="item?.is_partner; else elsePartner">
                              <ng-container *ngIf="!!item?.partnerCompany?.avatarFile?.thumbnail && !!host; else elseTemplatePartnerAvatar">
                                  <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" class="partner_avatar" (error)="onPartnerImgError($event)" [src]="host + item?.partnerCompany?.avatarFile?.thumbnail + '?company_id=' + company?.id" alt="">
                              </ng-container>
                              <ng-template #elseTemplatePartnerAvatar>
                                  <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" class="partner_avatar" (error)="onPartnerImgError($event)" src="{{ imgRoute }}assets/img/partner.png" alt="">
                              </ng-template>
                            </ng-container>
                            <ng-template #elsePartner>
                              <ng-container *ngIf="item?.employee?.image; else elseTemplatePhoto">
                                <img [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }" [src]="item?.employee?.image">
                              </ng-container>
                              <ng-template #elseTemplatePhoto>
                                  <mat-icon [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }">account_circle</mat-icon>
                              </ng-template>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                      <div class="icons_line">
                        <div class="icons_wrp">
                          <ng-container *ngIf="item.discussion_id; else elseTemplateDisc">
                            <div class="chat">
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill="#6299E1" d="M24.6875 0.6875C25.3958 0.6875 26 0.958333 26.5 1.5C27.0417 2 27.3125 2.60417 27.3125 3.3125V19.3125C27.3125 20.0208 27.0417 20.6458 26.5 21.1875C26 21.7292 25.3958 22 24.6875 22H6L0.6875 27.3125V3.3125C0.6875 2.60417 0.9375 2 1.4375 1.5C1.97917 0.958333 2.60417 0.6875 3.3125 0.6875H24.6875Z"/>
                              </svg>
                              <div class="red_point" *ngIf="item?.unReadChats"></div>
                            </div>
                            <div class="to_files">
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.5 9.375C1.5 7.095 3.345 5.25 5.625 5.25H13.5C15.1575 5.25 16.5 6.5925 16.5 8.25C16.5 9.9075 15.1575 11.25 13.5 11.25H7.125C6.09 11.25 5.25 10.41 5.25 9.375C5.25 8.34 6.09 7.5 7.125 7.5H12.75V9H7.0575C6.645 9 6.645 9.75 7.0575 9.75H13.5C14.325 9.75 15 9.075 15 8.25C15 7.425 14.325 6.75 13.5 6.75H5.625C4.1775 6.75 3 7.9275 3 9.375C3 10.8225 4.1775 12 5.625 12H12.75V13.5H5.625C3.345 13.5 1.5 11.655 1.5 9.375Z" fill="#1877F2"/>
                              </svg>
                              <ng-container *ngIf="item?.discussion?.filesize">
                                <div class="filesize" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ item?.discussion?.file_stat_updated_at > 0 ? (item?.discussion?.file_stat_updated_at*1000 | date:'hh:mm a, MMM d, y':'':activeLang | yearPipe) : '' }}">
                                  {{ item?.discussion?.filesize | filesize }}
                                </div>
                              </ng-container>
                            </div>
                          </ng-container>
                          <ng-template #elseTemplateDisc>
                            <div class="chat" style="visibility: hidden;" (click)="goToChats(item)">
                              <span class="c_v">{{item?.chatsCount}}</span>
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill="#6299E1" d="M24.6875 0.6875C25.3958 0.6875 26 0.958333 26.5 1.5C27.0417 2 27.3125 2.60417 27.3125 3.3125V19.3125C27.3125 20.0208 27.0417 20.6458 26.5 21.1875C26 21.7292 25.3958 22 24.6875 22H6L0.6875 27.3125V3.3125C0.6875 2.60417 0.9375 2 1.4375 1.5C1.97917 0.958333 2.60417 0.6875 3.3125 0.6875H24.6875Z"/>
                              </svg>
                              <div class="red_point" *ngIf="item?.unReadChats"></div>
                            </div>
                            <div class="to_files">
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.5 9.375C1.5 7.095 3.345 5.25 5.625 5.25H13.5C15.1575 5.25 16.5 6.5925 16.5 8.25C16.5 9.9075 15.1575 11.25 13.5 11.25H7.125C6.09 11.25 5.25 10.41 5.25 9.375C5.25 8.34 6.09 7.5 7.125 7.5H12.75V9H7.0575C6.645 9 6.645 9.75 7.0575 9.75H13.5C14.325 9.75 15 9.075 15 8.25C15 7.425 14.325 6.75 13.5 6.75H5.625C4.1775 6.75 3 7.9275 3 9.375C3 10.8225 4.1775 12 5.625 12H12.75V13.5H5.625C3.345 13.5 1.5 11.655 1.5 9.375Z" fill="#1877F2"/>
                              </svg>
                              <ng-container *ngIf="item?.taskOperation?.filesize">
                                <div class="filesize" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ item?.taskOperation?.file_stat_updated_at > 0 ? (item?.taskOperation?.file_stat_updated_at*1000 | date:'hh:mm a, MMM d, y':'':activeLang | yearPipe) : '' }}">
                                  {{ item?.taskOperation?.filesize | filesize }}
                                </div>
                              </ng-container>
                            </div>
                          </ng-template>
                          
    
                        </div>
                        <div class="status_type">
                          <ng-container *ngIf="item.discussion_id; else elseTemplateType">
                            {{ "Chat" | translate }}
                          </ng-container>
                          <ng-template #elseTemplateType>
                            {{ "Work" | translate }}
                          </ng-template>
                        </div>
                      </div>
                    </div>
    
                  </div>
                  <div class="board_names">
                    <div class="job_type_line">
                      <span class="text_one_line">{{getColumnName(item?.taskOperation.operation_id)}}</span>
                      <span class="text_one_line" *ngIf="!!item?.discussion_id">{{item?.taskOperation?.name}}</span>
                      <span class="text_one_line">
                        <ng-container *ngIf="item?.task?.group?.name; else elseTemplateNBSP">
                          {{item?.task?.group?.name}}
                        </ng-container>
                      </span>
                    </div>
                    <div class="type_name text_one_line">
                      <ng-container *ngIf="item?.discussion_id; else elseTemplateItIsDiscussion">
                        {{ item?.discussion?.name}}
                      </ng-container>
                      <ng-template #elseTemplateItIsDiscussion>
                        <ng-container *ngIf="item?.taskOperation?.name; else elseTemplateNBSP">
                          {{ item?.taskOperation?.name }}
                        </ng-container>
                      </ng-template>
                    </div>
                    <div class="type_comment">
                      <ng-container *ngIf="item?.discussion_id; else elseTemplateItIsDisc">
                        <ng-container *ngIf="item?.discussion?.lastPost?.action; else elseTemplateHasAction">
                          <div class="chat_last_post">
    
                            <ng-container *ngIf="!!item?.discussion?.lastPost?.action?.createdEmployee?.image; else elseOwnerTemplateLastPost">
                                <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5" [src]="item?.discussion?.lastPost?.action?.createdEmployee?.image" alt="">
                            </ng-container>
                            <ng-template #elseOwnerTemplateLastPost>
                                <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5">account_circle</mat-icon>
                            </ng-template>
    
                            {{ 'switched to' | translate }} 
                            <ng-container [ngSwitch]="item?.discussion?.lastPost?.action?.action">
                              <ng-container *ngSwitchCase="'task_employee_status_change'">
                                <b style="margin-left: 5px; margin-right: 5px;">{{ getOperationStatusName(item?.discussion?.lastPost?.action?.task_employee_status_id) }}</b>
                                {{ "for" | translate }}
                                <ng-container *ngIf="!!item?.discussion?.lastPost?.action?.employee?.image; else elseActionOwnerTemplate">
                                    <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5" [src]="item?.discussion?.lastPost?.action?.employee?.image" alt="">
                                </ng-container>
                                <ng-template #elseActionOwnerTemplate>
                                    <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5">account_circle</mat-icon>
                                </ng-template>
                              </ng-container>
                              <ng-container *ngSwitchCase="'discussion_status'">
                                 <b style="margin-left: 5px;">{{ getOperationStatusName(item?.discussion?.lastPost?.action?.discussion_status_id) }}</b>
                              </ng-container>
                            </ng-container>
                          </div>
                        </ng-container>
    
                        <ng-template #elseTemplateHasAction>
                          <div class="chat_last_post">
                            <ng-container *ngIf="!!item?.discussion?.lastPost?.employee?.image; else elseOwnerTemplateLastPost">
                                <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.employee, company_id: company?.id }" [src]="item?.discussion?.lastPost?.employee?.image" alt="">
                            </ng-container>
                            <ng-template #elseOwnerTemplateLastPost>
                                <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.employee, company_id: company?.id }">account_circle</mat-icon>
                            </ng-template>
                            
                            <div class="last_post_file" *ngIf="!!item?.discussion?.lastPost?.file_id">
                              <div class="file_view">
                                <ng-container [ngSwitch]="understandFileType(item?.discussion?.lastPost?.file?.content_type)">
                                    <ng-container *ngSwitchCase="'video'">
                                        <div class="file movie d-f-c">
                                            <ng-container *ngIf="item?.discussion?.lastPost?.file?.thumbnail; else elseTemplateThumbnail">
                                                <div class="movie_thumb" >
                                                    <img style="max-width: 100%; max-height: 100%;" (error)="onImgError($event)" [src]="host + item?.discussion?.lastPost?.file?.thumbnail + '?company_id=' + company?.id">
                                                </div>
                                            </ng-container>
                                            <ng-template #elseTemplateThumbnail>
                                                <mat-icon class="file_img_icon" style="color: #3f51b5">
                                                    movie
                                                </mat-icon>
                                            </ng-template>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'pdf'">
                                      <div class="pdf">
                                          <svg height="800px" width="800px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                              viewBox="0 0 303.188 303.188" xml:space="preserve">
                                              <g>
                                                  <polygon style="fill:#E8E8E8;" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 	"/>
                                                  <path style="fill:#FB3449;" d="M230.013,149.935c-3.643-6.493-16.231-8.533-22.006-9.451c-4.552-0.724-9.199-0.94-13.803-0.936
                                                      c-3.615-0.024-7.177,0.154-10.693,0.354c-1.296,0.087-2.579,0.199-3.861,0.31c-1.314-1.36-2.584-2.765-3.813-4.202
                                                      c-7.82-9.257-14.134-19.755-19.279-30.664c1.366-5.271,2.459-10.772,3.119-16.485c1.205-10.427,1.619-22.31-2.288-32.251
                                                      c-1.349-3.431-4.946-7.608-9.096-5.528c-4.771,2.392-6.113,9.169-6.502,13.973c-0.313,3.883-0.094,7.776,0.558,11.594
                                                      c0.664,3.844,1.733,7.494,2.897,11.139c1.086,3.342,2.283,6.658,3.588,9.943c-0.828,2.586-1.707,5.127-2.63,7.603
                                                      c-2.152,5.643-4.479,11.004-6.717,16.161c-1.18,2.557-2.335,5.06-3.465,7.507c-3.576,7.855-7.458,15.566-11.815,23.02
                                                      c-10.163,3.585-19.283,7.741-26.857,12.625c-4.063,2.625-7.652,5.476-10.641,8.603c-2.822,2.952-5.69,6.783-5.941,11.024
                                                      c-0.141,2.394,0.807,4.717,2.768,6.137c2.697,2.015,6.271,1.881,9.4,1.225c10.25-2.15,18.121-10.961,24.824-18.387
                                                      c4.617-5.115,9.872-11.61,15.369-19.465c0.012-0.018,0.024-0.036,0.037-0.054c9.428-2.923,19.689-5.391,30.579-7.205
                                                      c4.975-0.825,10.082-1.5,15.291-1.974c3.663,3.431,7.621,6.555,11.939,9.164c3.363,2.069,6.94,3.816,10.684,5.119
                                                      c3.786,1.237,7.595,2.247,11.528,2.886c1.986,0.284,4.017,0.413,6.092,0.335c4.631-0.175,11.278-1.951,11.714-7.57
                                                      C231.127,152.765,230.756,151.257,230.013,149.935z M119.144,160.245c-2.169,3.36-4.261,6.382-6.232,9.041
                                                      c-4.827,6.568-10.34,14.369-18.322,17.286c-1.516,0.554-3.512,1.126-5.616,1.002c-1.874-0.11-3.722-0.937-3.637-3.065
                                                      c0.042-1.114,0.587-2.535,1.423-3.931c0.915-1.531,2.048-2.935,3.275-4.226c2.629-2.762,5.953-5.439,9.777-7.918
                                                      c5.865-3.805,12.867-7.23,20.672-10.286C120.035,158.858,119.587,159.564,119.144,160.245z M146.366,75.985
                                                      c-0.602-3.514-0.693-7.077-0.323-10.503c0.184-1.713,0.533-3.385,1.038-4.952c0.428-1.33,1.352-4.576,2.826-4.993
                                                      c2.43-0.688,3.177,4.529,3.452,6.005c1.566,8.396,0.186,17.733-1.693,25.969c-0.299,1.31-0.632,2.599-0.973,3.883
                                                      c-0.582-1.601-1.137-3.207-1.648-4.821C147.945,83.048,146.939,79.482,146.366,75.985z M163.049,142.265
                                                      c-9.13,1.48-17.815,3.419-25.979,5.708c0.983-0.275,5.475-8.788,6.477-10.555c4.721-8.315,8.583-17.042,11.358-26.197
                                                      c4.9,9.691,10.847,18.962,18.153,27.214c0.673,0.749,1.357,1.489,2.053,2.22C171.017,141.096,166.988,141.633,163.049,142.265z
                                                      M224.793,153.959c-0.334,1.805-4.189,2.837-5.988,3.121c-5.316,0.836-10.94,0.167-16.028-1.542
                                                      c-3.491-1.172-6.858-2.768-10.057-4.688c-3.18-1.921-6.155-4.181-8.936-6.673c3.429-0.206,6.9-0.341,10.388-0.275
                                                      c3.488,0.035,7.003,0.211,10.475,0.664c6.511,0.726,13.807,2.961,18.932,7.186C224.588,152.585,224.91,153.321,224.793,153.959z"/>
                                                  <polygon style="fill:#FB3449;" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0 	"/>
                                                  <g>
                                                      <path style="fill:#A4A9AD;" d="M126.841,241.152c0,5.361-1.58,9.501-4.742,12.421c-3.162,2.921-7.652,4.381-13.472,4.381h-3.643
                                                          v15.917H92.022v-47.979h16.606c6.06,0,10.611,1.324,13.652,3.971C125.321,232.51,126.841,236.273,126.841,241.152z
                                                          M104.985,247.387h2.363c1.947,0,3.495-0.546,4.644-1.641c1.149-1.094,1.723-2.604,1.723-4.529c0-3.238-1.794-4.857-5.382-4.857
                                                          h-3.348C104.985,236.36,104.985,247.387,104.985,247.387z"/>
                                                      <path style="fill:#A4A9AD;" d="M175.215,248.864c0,8.007-2.205,14.177-6.613,18.509s-10.606,6.498-18.591,6.498h-15.523v-47.979
                                                          h16.606c7.701,0,13.646,1.969,17.836,5.907C173.119,235.737,175.215,241.426,175.215,248.864z M161.76,249.324
                                                          c0-4.398-0.87-7.657-2.609-9.78c-1.739-2.122-4.381-3.183-7.926-3.183h-3.773v26.877h2.888c3.939,0,6.826-1.143,8.664-3.43
                                                          C160.841,257.523,161.76,254.028,161.76,249.324z"/>
                                                      <path style="fill:#A4A9AD;" d="M196.579,273.871h-12.766v-47.979h28.355v10.403h-15.589v9.156h14.374v10.403h-14.374
                                                          L196.579,273.871L196.579,273.871z"/>
                                                  </g>
                                                  <polygon style="fill:#D1D3D3;" points="219.821,50.525 270.346,50.525 219.821,0 	"/>
                                              </g>
                                          </svg>
                                      </div>
                                  </ng-container>
                                    <ng-container *ngSwitchCase="'image'">
                                        <div class="img_wrp">
                                            <img (error)="onImgError($event)" [src]="host + (item?.discussion?.lastPost?.file?.thumbnail ? (item?.discussion?.lastPost?.file?.thumbnail + '?company_id=' + company?.id) : (item?.discussion?.lastPost?.file?.original + '?company_id=' + company?.id))" alt="">
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                      <ng-container *ngIf="!!item?.discussion?.lastPost?.file?.thumbnail; else elseTemplateHasThumb">
                                        <div class="img_wrp">
                                          <img (error)="onImgError($event)" [src]="host + item?.discussion?.lastPost?.file?.thumbnail  + '?company_id=' + company?.id" alt="">
                                        </div>
                                      </ng-container>
                                      <ng-template #elseTemplateHasThumb>
                                        <div class="file d-f-c">
                                          <mat-icon class="file_img_icon mr-1" style="color: #3f51b5">
                                              insert_drive_file
                                          </mat-icon>
                                      </div>
                                      </ng-template>
                                    </ng-container>
                                </ng-container>
                              </div>
                              <!-- <div class="file_info">
                                  <span class="file_name">{{ chat?.lastPost?.file?.filename }}</span>
                                  <span class="file_size">{{ chat?.lastPost?.file?.filesize | filesize }}</span>
                              </div> -->
    
                            </div>
                            
                            <!-- <div class="text_one_line">
                              {{ item?.discussion?.lastPost?.text }}
                            </div> -->
                            <div class="text_one_line" [innerHTML]='item?.discussion?.lastPost?.text ? (item?.discussion?.lastPost?.text.replaceAll("\n"," ").replaceAll("</BR>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("<br>"," ")) : ""'></div>
                        </div>
                        </ng-template>
                      </ng-container>
                      <ng-template #elseTemplateItIsDisc>
                        <div class="empl_comment">
                          <ng-container *ngIf="item?.taskOperation?.employee_comment; else elseTemplateNBSP">
                            {{item?.taskOperation?.employee_comment}}
                          </ng-container>
                        </div>
                      </ng-template>
                      
    
                    </div>
                    <div class="task_name_wrp">
                      <div class="task_name text_one_line">
                        {{item?.task?.name}}
                      </div>
                      <div class="task_ids">
                        <div>{{item?.task?.internal_id}}</div>
                        <div>{{item?.task?.id}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="clients" *ngIf="item?.clients?.length > 0">
                    <div class="clients_title">
                      {{ "Clients" | translate }}:
                    </div>
                    <ng-container *ngFor="let client of item?.clients; let ind = index;">
                      <ng-container *ngIf="ind <= 2">
                        <app-user [class]="'client'" [employee]="client?.client"></app-user>
                      </ng-container>
                      
                      <div class="clients_more" *ngIf="ind == item?.clients?.length - 1 && ind > 2">
                        +{{ item?.clients?.length - 3}}
                      </div>
                    </ng-container>
    
                  </div>
                  <div class="hover_drag" (click)="$event.stopPropagation()" cdkDragHandle>
                    <div>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #elseTemplateDesktopPage>
        <mat-tab-group mat-align-tabs="center" class="board_tabs" [selectedIndex]="selectedIndex" (selectedIndexChange)="changeTab($event)">
          <mat-tab>
              <ng-template mat-tab-label>
                  <button [matMenuTriggerFor]="multiMenu" style="height: 28px; min-width: auto !important; padding: 0 6px !important;" class="mobile_board_collection_btn" *ngIf="!showFilter && boardCollection?.selected?.length && (company?.permissions?.includes('owner') || company?.permissions.includes('admin') || company?.permissions?.includes('manager'))" mat-raised-button color="primary">
                    {{boardCollection?.selected?.length}}
                    <mat-icon>settings</mat-icon>
                  </button>
                  <mat-menu #multiMenu="matMenu" xPosition="after">
                    <button (click)="multiEditStartAt()" mat-menu-item>
                      <mat-icon>schedule</mat-icon>
                      {{ "Edit start at" | translate }}
                    </button>
                    <button mat-menu-item *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('top', 'all', todo)">
                      <mat-icon>vertical_align_top</mat-icon>
                      {{ "Move to top" | translate }}
                    </button>
                    <button mat-menu-item *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('bottom', 'all', todo)">
                      <mat-icon>vertical_align_bottom</mat-icon>
                      {{ "Move to bottom" | translate }}
                    </button>
                    <button mat-menu-item *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('top', 'step', todo)">
                      <mat-icon>plus_one</mat-icon>
                      {{ "Move to 1 step up" | translate }}
                    </button>
                    <button mat-menu-item *ngIf="!isAllTodoSelected() && !hasDoneValue()" (click)="multiMove('bottom', 'step', todo)">
                      <mat-icon>exposure_neg_1</mat-icon>
                      {{ "Move to 1 step down" | translate }}
                    </button>
                  </mat-menu>
                  {{ 'To Do' | translate }}
              </ng-template>
              <div class="container board_out">
                <div
                    #todoContainer
                    [id]="'todo'"
                    class="reports-list">
                    <div class="board_item" (click)="item.discussion_id ? openChat($event, item, i, todo) : openJob($event, item, i, todo)" *ngFor="let item of todo; let i = index;" [ngClass]="{'has_clients': item?.clients?.length > 0, 'no_clients': item?.clients?.length == 0 || !item?.clients}">
                      
                      <mat-progress-bar mode="indeterminate" *ngIf="item.isLoad" class="mat_proggress_w8 job_proggress"></mat-progress-bar>
                      <div class="board_btns" [ngClass]="{'show': is_mobile || boardCollection.isSelected(item)}">
                        <div class="check_wrp">
                          <mat-checkbox color="primary" class="example-margin" (click)="clickOnCheck($event, item, i, todo); $event.stopPropagation()" (change)="$event ? toggleItem(item) : null" [checked]='boardCollection.isSelected(item)'></mat-checkbox>
                        </div>
                      </div>
    
                        <div class="board_info">
                          <div class="dates">
                            <div class="left">
                              <div class="status_id">
                                <span>{{item.id}}</span>
                                <span>
                                  {{ getTaskStatusById(item?.task?.status_id)?.name }}
                                </span>
                              </div>
                              <div class="start_at_date"
                              [ngClass]="{'time_of': item.initial_start_at < today}"
                              #tooltip="matTooltip"
                              matTooltip="{{ item.initial_start_at*1000 | date:'MMM dd. Y, hh:mm a':'':activeLang }}"
                              [matTooltipPosition]="'below'">{{ item.start_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                              <div class="start_at_time">
                                {{ item.start_at*1000 | date:'hh:mm a':'':activeLang | yearPipe }}
                              </div>
                            </div>
                            <div class="right">
                              <div>{{ item.created_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                              <div>{{ item.updated_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                            </div>
    
                          </div>
    
                          <div class="bottom_info">
                            <div class="empl_line">
                              <div class="inside_job" [ngClass]="{
                                'first': item?.status_id == '1',
                                'second': item?.status_id == '2',
                                'third': item?.status_id == '3',
                                'fours': item?.status_id == '4',
                                'fives': item?.status_id == '5',
                                'sixs': item?.status_id == '6',
                                'nine': item?.status_id == '97',
                                'seven': item?.status_id == '98',
                                'eight': item?.status_id == '99'}">
                                <span>{{ (getOperationStatusName(item?.status_id) | translate).length > 15 ? ((getOperationStatusName(item?.status_id) | translate) | slice:0:12) + "..." : (getOperationStatusName(item?.status_id) | translate) }}</span>  
                              </div>
                              <div class="employees">
                                <div class="employee">
                                  <ng-container *ngIf="item?.is_partner; else elsePartner">
                                    <ng-container *ngIf="!!item?.partnerCompany?.avatarFile?.thumbnail && !!host; else elseTemplatePartnerAvatar">
                                        <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" class="partner_avatar" (error)="onPartnerImgError($event)" [src]="host + item?.partnerCompany?.avatarFile?.thumbnail + '?company_id=' + company?.id" alt="">
                                    </ng-container>
                                    <ng-template #elseTemplatePartnerAvatar>
                                        <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" class="partner_avatar" (error)="onPartnerImgError($event)" src="{{ imgRoute }}assets/img/partner.png" alt="">
                                    </ng-template>
                                  </ng-container>
                                  <ng-template #elsePartner>
                                    <ng-container *ngIf="item?.employee?.image; else elseTemplatePhoto">
                                      <img [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }" [src]="item?.employee?.image">
                                    </ng-container>
                                    <ng-template #elseTemplatePhoto>
                                        <mat-icon [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }">account_circle</mat-icon>
                                    </ng-template>
                                  </ng-template>
                                </div>
                              </div>
                            </div>
                            <div class="icons_line">
                              <div class="icons_wrp">
                                <ng-container *ngIf="item.discussion_id; else elseTemplateDisc">
                                  <div class="chat">
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill="#6299E1" d="M24.6875 0.6875C25.3958 0.6875 26 0.958333 26.5 1.5C27.0417 2 27.3125 2.60417 27.3125 3.3125V19.3125C27.3125 20.0208 27.0417 20.6458 26.5 21.1875C26 21.7292 25.3958 22 24.6875 22H6L0.6875 27.3125V3.3125C0.6875 2.60417 0.9375 2 1.4375 1.5C1.97917 0.958333 2.60417 0.6875 3.3125 0.6875H24.6875Z"/>
                                    </svg>
                                    <div class="red_point" *ngIf="item?.unReadChats"></div>
                                  </div>
                                  <div class="to_files">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.5 9.375C1.5 7.095 3.345 5.25 5.625 5.25H13.5C15.1575 5.25 16.5 6.5925 16.5 8.25C16.5 9.9075 15.1575 11.25 13.5 11.25H7.125C6.09 11.25 5.25 10.41 5.25 9.375C5.25 8.34 6.09 7.5 7.125 7.5H12.75V9H7.0575C6.645 9 6.645 9.75 7.0575 9.75H13.5C14.325 9.75 15 9.075 15 8.25C15 7.425 14.325 6.75 13.5 6.75H5.625C4.1775 6.75 3 7.9275 3 9.375C3 10.8225 4.1775 12 5.625 12H12.75V13.5H5.625C3.345 13.5 1.5 11.655 1.5 9.375Z" fill="#1877F2"/>
                                    </svg>
                                    <ng-container *ngIf="item?.discussion?.filesize">
                                      <div class="filesize" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ item?.discussion?.file_stat_updated_at > 0 ? (item?.discussion?.file_stat_updated_at*1000 | date:'hh:mm a, MMM d, y':'':activeLang | yearPipe) : '' }}">
                                        {{ item?.discussion?.filesize | filesize }}
                                      </div>
                                    </ng-container>
                                  </div>
                                </ng-container>
                                <ng-template #elseTemplateDisc>
                                  <div class="chat" style="visibility: hidden;" (click)="goToChats(item)">
                                    <span class="c_v">{{item?.chatsCount}}</span>
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path fill="#6299E1" d="M24.6875 0.6875C25.3958 0.6875 26 0.958333 26.5 1.5C27.0417 2 27.3125 2.60417 27.3125 3.3125V19.3125C27.3125 20.0208 27.0417 20.6458 26.5 21.1875C26 21.7292 25.3958 22 24.6875 22H6L0.6875 27.3125V3.3125C0.6875 2.60417 0.9375 2 1.4375 1.5C1.97917 0.958333 2.60417 0.6875 3.3125 0.6875H24.6875Z"/>
                                    </svg>
                                    <div class="red_point" *ngIf="item?.unReadChats"></div>
                                  </div>
                                  <div class="to_files">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.5 9.375C1.5 7.095 3.345 5.25 5.625 5.25H13.5C15.1575 5.25 16.5 6.5925 16.5 8.25C16.5 9.9075 15.1575 11.25 13.5 11.25H7.125C6.09 11.25 5.25 10.41 5.25 9.375C5.25 8.34 6.09 7.5 7.125 7.5H12.75V9H7.0575C6.645 9 6.645 9.75 7.0575 9.75H13.5C14.325 9.75 15 9.075 15 8.25C15 7.425 14.325 6.75 13.5 6.75H5.625C4.1775 6.75 3 7.9275 3 9.375C3 10.8225 4.1775 12 5.625 12H12.75V13.5H5.625C3.345 13.5 1.5 11.655 1.5 9.375Z" fill="#1877F2"/>
                                    </svg>
                                    <ng-container *ngIf="item?.taskOperation?.filesize">
                                      <div class="filesize" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ item?.taskOperation?.file_stat_updated_at > 0 ? (item?.taskOperation?.file_stat_updated_at*1000 | date:'hh:mm a, MMM d, y':'':activeLang | yearPipe) : '' }}">
                                        {{ item?.taskOperation?.filesize | filesize }}
                                      </div>
                                    </ng-container>
                                  </div>
                                </ng-template>
                                
    
                              </div>
                              <div class="status_type">
                                <ng-container *ngIf="item.discussion_id; else elseTemplateType">
                                  {{ "Chat" | translate }}
                                </ng-container>
                                <ng-template #elseTemplateType>
                                  {{ "Work" | translate }}
                                </ng-template>
                              </div>
                            </div>
                          </div>
    
                        </div>
                        <div class="board_names">
                          <div class="job_type_line">
                            <span class="text_one_line">{{getColumnName(item?.taskOperation.operation_id)}}</span>
                            <span class="text_one_line" *ngIf="!!item?.discussion_id">{{item?.taskOperation?.name}}</span>
                            <span class="text_one_line">
                              <ng-container *ngIf="item?.task?.group?.name; else elseTemplateNBSP">
                                {{item?.task?.group?.name}}
                              </ng-container>
                            </span>
                          </div>
                          <div class="type_name text_one_line">
                            <ng-container *ngIf="item?.discussion_id; else elseTemplateItIsDiscussion">
                              {{ item?.discussion?.name}}
                            </ng-container>
                            <ng-template #elseTemplateItIsDiscussion>
                              <ng-container *ngIf="item?.taskOperation?.name; else elseTemplateNBSP">
                                {{ item?.taskOperation?.name }}
                              </ng-container>
                            </ng-template>
                          </div>
                          <div class="type_comment">
                            <ng-container *ngIf="item?.discussion_id; else elseTemplateItIsDisc">
                              <ng-container *ngIf="item?.discussion?.lastPost?.action; else elseTemplateHasAction">
                                <div class="chat_last_post">
          
                                  <ng-container *ngIf="!!item?.discussion?.lastPost?.action?.createdEmployee?.image; else elseOwnerTemplateLastPost">
                                      <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5" [src]="item?.discussion?.lastPost?.action?.createdEmployee?.image" alt="">
                                  </ng-container>
                                  <ng-template #elseOwnerTemplateLastPost>
                                      <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5">account_circle</mat-icon>
                                  </ng-template>
          
                                  {{ 'switched to' | translate }} 
                                  <ng-container [ngSwitch]="item?.discussion?.lastPost?.action?.action">
                                    <ng-container *ngSwitchCase="'task_employee_status_change'">
                                      <b style="margin-left: 5px; margin-right: 5px;">{{ getOperationStatusName(item?.discussion?.lastPost?.action?.task_employee_status_id) }}</b>
                                      {{ "for" | translate }}
                                      <ng-container *ngIf="!!item?.discussion?.lastPost?.action?.employee?.image; else elseActionOwnerTemplate">
                                          <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5" [src]="item?.discussion?.lastPost?.action?.employee?.image" alt="">
                                      </ng-container>
                                      <ng-template #elseActionOwnerTemplate>
                                          <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5">account_circle</mat-icon>
                                      </ng-template>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'discussion_status'">
                                       <b style="margin-left: 5px;">{{ getOperationStatusName(item?.discussion?.lastPost?.action?.discussion_status_id) }}</b>
                                    </ng-container>
                                  </ng-container>
                                </div>
                              </ng-container>
          
                              <ng-template #elseTemplateHasAction>
                                <div class="chat_last_post">
                                  <ng-container *ngIf="!!item?.discussion?.lastPost?.employee?.image; else elseOwnerTemplateLastPost">
                                      <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.employee, company_id: company?.id }" [src]="item?.discussion?.lastPost?.employee?.image" alt="">
                                  </ng-container>
                                  <ng-template #elseOwnerTemplateLastPost>
                                      <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.employee, company_id: company?.id }">account_circle</mat-icon>
                                  </ng-template>
                                  
                                  <div class="last_post_file" *ngIf="!!item?.discussion?.lastPost?.file_id">
                                    <div class="file_view">
                                      <ng-container [ngSwitch]="understandFileType(item?.discussion?.lastPost?.file?.content_type)">
                                          <ng-container *ngSwitchCase="'video'">
                                              <div class="file movie d-f-c">
                                                  <ng-container *ngIf="item?.discussion?.lastPost?.file?.thumbnail; else elseTemplateThumbnail">
                                                      <div class="movie_thumb" >
                                                          <img style="max-width: 100%; max-height: 100%;" (error)="onImgError($event)" [src]="host + item?.discussion?.lastPost?.file?.thumbnail">
                                                      </div>
                                                  </ng-container>
                                                  <ng-template #elseTemplateThumbnail>
                                                      <mat-icon class="file_img_icon" style="color: #3f51b5">
                                                          movie
                                                      </mat-icon>
                                                  </ng-template>
                                              </div>
                                          </ng-container>
                                          <ng-container *ngSwitchCase="'pdf'">
                                            <div class="pdf">
                                                <svg height="800px" width="800px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                                    viewBox="0 0 303.188 303.188" xml:space="preserve">
                                                    <g>
                                                        <polygon style="fill:#E8E8E8;" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 	"/>
                                                        <path style="fill:#FB3449;" d="M230.013,149.935c-3.643-6.493-16.231-8.533-22.006-9.451c-4.552-0.724-9.199-0.94-13.803-0.936
                                                            c-3.615-0.024-7.177,0.154-10.693,0.354c-1.296,0.087-2.579,0.199-3.861,0.31c-1.314-1.36-2.584-2.765-3.813-4.202
                                                            c-7.82-9.257-14.134-19.755-19.279-30.664c1.366-5.271,2.459-10.772,3.119-16.485c1.205-10.427,1.619-22.31-2.288-32.251
                                                            c-1.349-3.431-4.946-7.608-9.096-5.528c-4.771,2.392-6.113,9.169-6.502,13.973c-0.313,3.883-0.094,7.776,0.558,11.594
                                                            c0.664,3.844,1.733,7.494,2.897,11.139c1.086,3.342,2.283,6.658,3.588,9.943c-0.828,2.586-1.707,5.127-2.63,7.603
                                                            c-2.152,5.643-4.479,11.004-6.717,16.161c-1.18,2.557-2.335,5.06-3.465,7.507c-3.576,7.855-7.458,15.566-11.815,23.02
                                                            c-10.163,3.585-19.283,7.741-26.857,12.625c-4.063,2.625-7.652,5.476-10.641,8.603c-2.822,2.952-5.69,6.783-5.941,11.024
                                                            c-0.141,2.394,0.807,4.717,2.768,6.137c2.697,2.015,6.271,1.881,9.4,1.225c10.25-2.15,18.121-10.961,24.824-18.387
                                                            c4.617-5.115,9.872-11.61,15.369-19.465c0.012-0.018,0.024-0.036,0.037-0.054c9.428-2.923,19.689-5.391,30.579-7.205
                                                            c4.975-0.825,10.082-1.5,15.291-1.974c3.663,3.431,7.621,6.555,11.939,9.164c3.363,2.069,6.94,3.816,10.684,5.119
                                                            c3.786,1.237,7.595,2.247,11.528,2.886c1.986,0.284,4.017,0.413,6.092,0.335c4.631-0.175,11.278-1.951,11.714-7.57
                                                            C231.127,152.765,230.756,151.257,230.013,149.935z M119.144,160.245c-2.169,3.36-4.261,6.382-6.232,9.041
                                                            c-4.827,6.568-10.34,14.369-18.322,17.286c-1.516,0.554-3.512,1.126-5.616,1.002c-1.874-0.11-3.722-0.937-3.637-3.065
                                                            c0.042-1.114,0.587-2.535,1.423-3.931c0.915-1.531,2.048-2.935,3.275-4.226c2.629-2.762,5.953-5.439,9.777-7.918
                                                            c5.865-3.805,12.867-7.23,20.672-10.286C120.035,158.858,119.587,159.564,119.144,160.245z M146.366,75.985
                                                            c-0.602-3.514-0.693-7.077-0.323-10.503c0.184-1.713,0.533-3.385,1.038-4.952c0.428-1.33,1.352-4.576,2.826-4.993
                                                            c2.43-0.688,3.177,4.529,3.452,6.005c1.566,8.396,0.186,17.733-1.693,25.969c-0.299,1.31-0.632,2.599-0.973,3.883
                                                            c-0.582-1.601-1.137-3.207-1.648-4.821C147.945,83.048,146.939,79.482,146.366,75.985z M163.049,142.265
                                                            c-9.13,1.48-17.815,3.419-25.979,5.708c0.983-0.275,5.475-8.788,6.477-10.555c4.721-8.315,8.583-17.042,11.358-26.197
                                                            c4.9,9.691,10.847,18.962,18.153,27.214c0.673,0.749,1.357,1.489,2.053,2.22C171.017,141.096,166.988,141.633,163.049,142.265z
                                                            M224.793,153.959c-0.334,1.805-4.189,2.837-5.988,3.121c-5.316,0.836-10.94,0.167-16.028-1.542
                                                            c-3.491-1.172-6.858-2.768-10.057-4.688c-3.18-1.921-6.155-4.181-8.936-6.673c3.429-0.206,6.9-0.341,10.388-0.275
                                                            c3.488,0.035,7.003,0.211,10.475,0.664c6.511,0.726,13.807,2.961,18.932,7.186C224.588,152.585,224.91,153.321,224.793,153.959z"/>
                                                        <polygon style="fill:#FB3449;" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0 	"/>
                                                        <g>
                                                            <path style="fill:#A4A9AD;" d="M126.841,241.152c0,5.361-1.58,9.501-4.742,12.421c-3.162,2.921-7.652,4.381-13.472,4.381h-3.643
                                                                v15.917H92.022v-47.979h16.606c6.06,0,10.611,1.324,13.652,3.971C125.321,232.51,126.841,236.273,126.841,241.152z
                                                                M104.985,247.387h2.363c1.947,0,3.495-0.546,4.644-1.641c1.149-1.094,1.723-2.604,1.723-4.529c0-3.238-1.794-4.857-5.382-4.857
                                                                h-3.348C104.985,236.36,104.985,247.387,104.985,247.387z"/>
                                                            <path style="fill:#A4A9AD;" d="M175.215,248.864c0,8.007-2.205,14.177-6.613,18.509s-10.606,6.498-18.591,6.498h-15.523v-47.979
                                                                h16.606c7.701,0,13.646,1.969,17.836,5.907C173.119,235.737,175.215,241.426,175.215,248.864z M161.76,249.324
                                                                c0-4.398-0.87-7.657-2.609-9.78c-1.739-2.122-4.381-3.183-7.926-3.183h-3.773v26.877h2.888c3.939,0,6.826-1.143,8.664-3.43
                                                                C160.841,257.523,161.76,254.028,161.76,249.324z"/>
                                                            <path style="fill:#A4A9AD;" d="M196.579,273.871h-12.766v-47.979h28.355v10.403h-15.589v9.156h14.374v10.403h-14.374
                                                                L196.579,273.871L196.579,273.871z"/>
                                                        </g>
                                                        <polygon style="fill:#D1D3D3;" points="219.821,50.525 270.346,50.525 219.821,0 	"/>
                                                    </g>
                                                </svg>
                                            </div>
                                        </ng-container>
                                          <ng-container *ngSwitchCase="'image'">
                                              <div class="img_wrp">
                                                  <img (error)="onImgError($event)" [src]="host + (item?.discussion?.lastPost?.file?.thumbnail ? (item?.discussion?.lastPost?.file?.thumbnail + '?company_id=' + company?.id) : (item?.discussion?.lastPost?.file?.original + '?company_id=' + company?.id))" alt="">
                                              </div>
                                          </ng-container>
                                          <ng-container *ngSwitchDefault>
                                            <ng-container *ngIf="!!item?.discussion?.lastPost?.file?.thumbnail; else elseTemplateHasThumb">
                                              <div class="img_wrp">
                                                <img (error)="onImgError($event)" [src]="host + item?.discussion?.lastPost?.file?.thumbnail + '?company_id=' + company?.id" alt="">
                                              </div>
                                            </ng-container>
                                            <ng-template #elseTemplateHasThumb>
                                              <div class="file d-f-c">
                                                <mat-icon class="file_img_icon mr-1" style="color: #3f51b5">
                                                    insert_drive_file
                                                </mat-icon>
                                            </div>
                                            </ng-template>
                                          </ng-container>
                                      </ng-container>
                                    </div>
                                    <!-- <div class="file_info">
                                        <span class="file_name">{{ chat?.lastPost?.file?.filename }}</span>
                                        <span class="file_size">{{ chat?.lastPost?.file?.filesize | filesize }}</span>
                                    </div> -->
          
                                  </div>
                                  
                                  <!-- <div class="text_one_line">
                                    {{ item?.discussion?.lastPost?.text }}
                                  </div> -->
                                  <div class="text_one_line" [innerHTML]='item?.discussion?.lastPost?.text ? (item?.discussion?.lastPost?.text.replaceAll("\n"," ").replaceAll("</BR>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("<br>"," ")) : ""'></div>
                              </div>
                              </ng-template>
                            </ng-container>
                            <ng-template #elseTemplateItIsDisc>
                              <div class="empl_comment">
                                <ng-container *ngIf="item?.taskOperation?.employee_comment; else elseTemplateNBSP">
                                  {{item?.taskOperation?.employee_comment}}
                                </ng-container>
                              </div>
                            </ng-template>
                            
    
                          </div>
                          <div class="task_name_wrp">
                            <div class="task_name text_one_line">
                              {{item?.task?.name}}
                            </div>
                            <div class="task_ids">
                              <div>{{item?.task?.internal_id}}</div>
                              <div>{{item?.task?.id}}</div>
                            </div>
                          </div>
                        </div>
                        <div class="clients" *ngIf="item?.clients?.length > 0">
                          <div class="clients_title">
                            {{ "Clients" | translate }}:
                          </div>
                          <ng-container *ngFor="let client of item?.clients; let ind = index;">
                            <ng-container *ngIf="ind <= 2">
                              <app-user [class]="'client'" [employee]="client?.client"></app-user>
                            </ng-container>
                            
                            <div class="clients_more" *ngIf="ind == item?.clients?.length - 1 && ind > 2">
                              +{{ item?.clients?.length - 3}}
                            </div>
                          </ng-container>
    
                        </div>
                    </div>
                </div>
              </div>
          </mat-tab>
          <mat-tab>
            <ng-template mat-tab-label>
                {{ 'Done' | translate }}
            </ng-template>
            <div class="container board_out">
              <div
                #doneContainer
                [id]="'done'"
                class="reports-list">
                <div class="board_item" (click)="item.discussion_id ?  openChat($event, item, i, done) : openJob($event, item, i, done)" *ngFor="let item of done; let i = index;" [ngClass]="{'has_clients': item?.clients?.length > 0, 'no_clients': item?.clients?.length == 0 || !item?.clients}">
                  
                  <mat-progress-bar mode="indeterminate" *ngIf="item.isLoad" class="mat_proggress_w8 job_proggress"></mat-progress-bar>
                  <div class="board_btns" [ngClass]="{'show': is_mobile || boardCollection.isSelected(item)}">
                    <div class="check_wrp">
                      <mat-checkbox color="primary" class="example-margin" (click)="clickOnCheck($event, item, i, done); $event.stopPropagation()" (change)="$event ? toggleItem(item) : null" [checked]='boardCollection.isSelected(item)'></mat-checkbox>
                    </div>
                  </div>
                  <div class="board_info">
    
                    <div class="dates">
                      <div class="left">
                        <div class="status_id">
                          <span>{{item.id}}</span>
                          <span>
                            {{ getTaskStatusById(item?.task?.status_id)?.name }}
                          </span>
                        </div>
                        <div class="start_at_date"
                        [ngClass]="{'time_of': item.initial_start_at < today}"
                        #tooltip="matTooltip"
                        matTooltip="{{ item.initial_start_at*1000 | date:'MMM dd. Y, hh:mm a':'':activeLang }}"
                        [matTooltipPosition]="'below'">{{ item.start_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                        <div class="start_at_time">
                          {{ item.start_at*1000 | date:'hh:mm a':'':activeLang | yearPipe }}
                        </div>
                      </div>
                      <div class="right">
                        <div>{{ item.created_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                        <div>{{ item.updated_at*1000 | date:'MMM dd. Y':'':activeLang | yearPipe }}</div>
                      </div>
    
                    </div>
    
                    <div class="bottom_info">
                      <div class="empl_line">
                        <div class="inside_job" [ngClass]="{
                          'first': item?.status_id == '1',
                          'second': item?.status_id == '2',
                          'third': item?.status_id == '3',
                          'fours': item?.status_id == '4',
                          'fives': item?.status_id == '5',
                          'sixs': item?.status_id == '6',
                          'nine': item?.status_id == '97',
                          'seven': item?.status_id == '98',
                          'eight': item?.status_id == '99'}">
                          <span>{{ (getOperationStatusName(item?.status_id) | translate).length > 15 ? ((getOperationStatusName(item?.status_id) | translate) | slice:0:12) + "..." : (getOperationStatusName(item?.status_id) | translate) }}</span>  
                        </div>
                        <div class="employees">
                          <div class="employee">
                            <ng-container *ngIf="item?.is_partner; else elsePartner">
                              <ng-container *ngIf="!!item?.partnerCompany?.avatarFile?.thumbnail && !!host; else elseTemplatePartnerAvatar">
                                  <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" class="partner_avatar" (error)="onPartnerImgError($event)" [src]="host + item?.partnerCompany?.avatarFile?.thumbnail + '?company_id=' + company?.id" alt="">
                              </ng-container>
                              <ng-template #elseTemplatePartnerAvatar>
                                  <img [appHoverUserInfo]="{ user: {partnerCompany: item?.partnerCompany}, company_id: company?.id }" class="partner_avatar" (error)="onPartnerImgError($event)" src="{{ imgRoute }}assets/img/partner.png" alt="">
                              </ng-template>
                            </ng-container>
                            <ng-template #elsePartner>
                              <ng-container *ngIf="item?.employee?.image; else elseTemplatePhoto">
                                <img [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }" [src]="item?.employee?.image">
                              </ng-container>
                              <ng-template #elseTemplatePhoto>
                                  <mat-icon [appHoverUserInfo]="{ user: item?.employee, company_id: company?.id }">account_circle</mat-icon>
                              </ng-template>
                            </ng-template>
                          </div>
                        </div>
                      </div>
                      <div class="icons_line">
                        <div class="icons_wrp">
                          <ng-container *ngIf="item.discussion_id; else elseTemplateDisc">
                            <div class="chat">
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill="#6299E1" d="M24.6875 0.6875C25.3958 0.6875 26 0.958333 26.5 1.5C27.0417 2 27.3125 2.60417 27.3125 3.3125V19.3125C27.3125 20.0208 27.0417 20.6458 26.5 21.1875C26 21.7292 25.3958 22 24.6875 22H6L0.6875 27.3125V3.3125C0.6875 2.60417 0.9375 2 1.4375 1.5C1.97917 0.958333 2.60417 0.6875 3.3125 0.6875H24.6875Z"/>
                              </svg>
                              <div class="red_point" *ngIf="item?.unReadChats"></div>
                            </div>
                            <div class="to_files">
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.5 9.375C1.5 7.095 3.345 5.25 5.625 5.25H13.5C15.1575 5.25 16.5 6.5925 16.5 8.25C16.5 9.9075 15.1575 11.25 13.5 11.25H7.125C6.09 11.25 5.25 10.41 5.25 9.375C5.25 8.34 6.09 7.5 7.125 7.5H12.75V9H7.0575C6.645 9 6.645 9.75 7.0575 9.75H13.5C14.325 9.75 15 9.075 15 8.25C15 7.425 14.325 6.75 13.5 6.75H5.625C4.1775 6.75 3 7.9275 3 9.375C3 10.8225 4.1775 12 5.625 12H12.75V13.5H5.625C3.345 13.5 1.5 11.655 1.5 9.375Z" fill="#1877F2"/>
                              </svg>
                              <ng-container *ngIf="item?.discussion?.filesize">
                                <div class="filesize" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ item?.discussion?.file_stat_updated_at > 0 ? (item?.discussion?.file_stat_updated_at*1000 | date:'hh:mm a, MMM d, y':'':activeLang | yearPipe) : '' }}">
                                  {{ item?.discussion?.filesize | filesize }}
                                </div>
                              </ng-container>
                            </div>
                          </ng-container>
                          <ng-template #elseTemplateDisc>
                            <div class="chat" style="visibility: hidden;" (click)="goToChats(item)">
                              <span class="c_v">{{item?.chatsCount}}</span>
                              <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill="#6299E1" d="M24.6875 0.6875C25.3958 0.6875 26 0.958333 26.5 1.5C27.0417 2 27.3125 2.60417 27.3125 3.3125V19.3125C27.3125 20.0208 27.0417 20.6458 26.5 21.1875C26 21.7292 25.3958 22 24.6875 22H6L0.6875 27.3125V3.3125C0.6875 2.60417 0.9375 2 1.4375 1.5C1.97917 0.958333 2.60417 0.6875 3.3125 0.6875H24.6875Z"/>
                              </svg>
                              <div class="red_point" *ngIf="item?.unReadChats"></div>
                            </div>
                            <div class="to_files">
                              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.5 9.375C1.5 7.095 3.345 5.25 5.625 5.25H13.5C15.1575 5.25 16.5 6.5925 16.5 8.25C16.5 9.9075 15.1575 11.25 13.5 11.25H7.125C6.09 11.25 5.25 10.41 5.25 9.375C5.25 8.34 6.09 7.5 7.125 7.5H12.75V9H7.0575C6.645 9 6.645 9.75 7.0575 9.75H13.5C14.325 9.75 15 9.075 15 8.25C15 7.425 14.325 6.75 13.5 6.75H5.625C4.1775 6.75 3 7.9275 3 9.375C3 10.8225 4.1775 12 5.625 12H12.75V13.5H5.625C3.345 13.5 1.5 11.655 1.5 9.375Z" fill="#1877F2"/>
                              </svg>
                              <ng-container *ngIf="item?.taskOperation?.filesize">
                                <div class="filesize" #tooltip="matTooltip" [matTooltipPosition]="'above'" matTooltip="{{ item?.taskOperation?.file_stat_updated_at > 0 ? (item?.taskOperation?.file_stat_updated_at*1000 | date:'hh:mm a, MMM d, y':'':activeLang | yearPipe) : '' }}">
                                  {{ item?.taskOperation?.filesize | filesize }}
                                </div>
                              </ng-container>
                            </div>
                          </ng-template>
                          
    
                        </div>
                        <div class="status_type">
                          <ng-container *ngIf="item.discussion_id; else elseTemplateType">
                            {{ "Chat" | translate }}
                          </ng-container>
                          <ng-template #elseTemplateType>
                            {{ "Work" | translate }}
                          </ng-template>
                        </div>
                      </div>
                    </div>
    
                  </div>
                  <div class="board_names">
                    <div class="job_type_line">
                      <span class="text_one_line">{{getColumnName(item?.taskOperation.operation_id)}}</span>
                      <span class="text_one_line" *ngIf="!!item?.discussion_id">{{item?.taskOperation?.name}}</span>
                      <span class="text_one_line">
                        <ng-container *ngIf="item?.task?.group?.name; else elseTemplateNBSP">
                          {{item?.task?.group?.name}}
                        </ng-container>
                      </span>
                    </div>
                    <div class="type_name text_one_line">
                      <ng-container *ngIf="item?.discussion_id; else elseTemplateItIsDiscussion">
                        {{ item?.discussion?.name}}
                      </ng-container>
                      <ng-template #elseTemplateItIsDiscussion>
                        <ng-container *ngIf="item?.taskOperation?.name; else elseTemplateNBSP">
                          {{ item?.taskOperation?.name }}
                        </ng-container>
                      </ng-template>
                    </div>
                    <div class="type_comment">
                      <ng-container *ngIf="item?.discussion_id; else elseTemplateItIsDisc">
                        <ng-container *ngIf="item?.discussion?.lastPost?.action; else elseTemplateHasAction">
                          <div class="chat_last_post">
    
                            <ng-container *ngIf="!!item?.discussion?.lastPost?.action?.createdEmployee?.image; else elseOwnerTemplateLastPost">
                                <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5" [src]="item?.discussion?.lastPost?.action?.createdEmployee?.image" alt="">
                            </ng-container>
                            <ng-template #elseOwnerTemplateLastPost>
                                <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.createdEmployee, company_id: company?.id }" class="mr-5">account_circle</mat-icon>
                            </ng-template>
    
                            {{ 'switched to' | translate }} 
                            <ng-container [ngSwitch]="item?.discussion?.lastPost?.action?.action">
                              <ng-container *ngSwitchCase="'task_employee_status_change'">
                                <b style="margin-left: 5px; margin-right: 5px;">{{ getOperationStatusName(item?.discussion?.lastPost?.action?.task_employee_status_id) }}</b>
                                {{ "for" | translate }}
                                <ng-container *ngIf="!!item?.discussion?.lastPost?.action?.employee?.image; else elseActionOwnerTemplate">
                                    <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5" [src]="item?.discussion?.lastPost?.action?.employee?.image" alt="">
                                </ng-container>
                                <ng-template #elseActionOwnerTemplate>
                                    <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.action?.employee, company_id: company?.id }" class="ml-5">account_circle</mat-icon>
                                </ng-template>
                              </ng-container>
                              <ng-container *ngSwitchCase="'discussion_status'">
                                 <b style="margin-left: 5px;">{{ getOperationStatusName(item?.discussion?.lastPost?.action?.discussion_status_id) }}</b>
                              </ng-container>
                            </ng-container>
                          </div>
                        </ng-container>
    
                        <ng-template #elseTemplateHasAction>
                          <div class="chat_last_post">
                            <ng-container *ngIf="!!item?.discussion?.lastPost?.employee?.image; else elseOwnerTemplateLastPost">
                                <img [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.employee, company_id: company?.id }" [src]="item?.discussion?.lastPost?.employee?.image" alt="">
                            </ng-container>
                            <ng-template #elseOwnerTemplateLastPost>
                                <mat-icon [appHoverUserInfo]="{ user: item?.discussion?.lastPost?.employee, company_id: company?.id }">account_circle</mat-icon>
                            </ng-template>
                            
                            <div class="last_post_file" *ngIf="!!item?.discussion?.lastPost?.file_id">
                              <div class="file_view">
                                <ng-container [ngSwitch]="understandFileType(item?.discussion?.lastPost?.file?.content_type)">
                                    <ng-container *ngSwitchCase="'video'">
                                        <div class="file movie d-f-c">
                                            <ng-container *ngIf="item?.discussion?.lastPost?.file?.thumbnail; else elseTemplateThumbnail">
                                                <div class="movie_thumb" >
                                                    <img style="max-width: 100%; max-height: 100%;" (error)="onImgError($event)" [src]="host + item?.discussion?.lastPost?.file?.thumbnail + '?company_id=' + company?.id">
                                                </div>
                                            </ng-container>
                                            <ng-template #elseTemplateThumbnail>
                                                <mat-icon class="file_img_icon" style="color: #3f51b5">
                                                    movie
                                                </mat-icon>
                                            </ng-template>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'pdf'">
                                      <div class="pdf">
                                          <svg height="800px" width="800px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                                              viewBox="0 0 303.188 303.188" xml:space="preserve">
                                              <g>
                                                  <polygon style="fill:#E8E8E8;" points="219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 	"/>
                                                  <path style="fill:#FB3449;" d="M230.013,149.935c-3.643-6.493-16.231-8.533-22.006-9.451c-4.552-0.724-9.199-0.94-13.803-0.936
                                                      c-3.615-0.024-7.177,0.154-10.693,0.354c-1.296,0.087-2.579,0.199-3.861,0.31c-1.314-1.36-2.584-2.765-3.813-4.202
                                                      c-7.82-9.257-14.134-19.755-19.279-30.664c1.366-5.271,2.459-10.772,3.119-16.485c1.205-10.427,1.619-22.31-2.288-32.251
                                                      c-1.349-3.431-4.946-7.608-9.096-5.528c-4.771,2.392-6.113,9.169-6.502,13.973c-0.313,3.883-0.094,7.776,0.558,11.594
                                                      c0.664,3.844,1.733,7.494,2.897,11.139c1.086,3.342,2.283,6.658,3.588,9.943c-0.828,2.586-1.707,5.127-2.63,7.603
                                                      c-2.152,5.643-4.479,11.004-6.717,16.161c-1.18,2.557-2.335,5.06-3.465,7.507c-3.576,7.855-7.458,15.566-11.815,23.02
                                                      c-10.163,3.585-19.283,7.741-26.857,12.625c-4.063,2.625-7.652,5.476-10.641,8.603c-2.822,2.952-5.69,6.783-5.941,11.024
                                                      c-0.141,2.394,0.807,4.717,2.768,6.137c2.697,2.015,6.271,1.881,9.4,1.225c10.25-2.15,18.121-10.961,24.824-18.387
                                                      c4.617-5.115,9.872-11.61,15.369-19.465c0.012-0.018,0.024-0.036,0.037-0.054c9.428-2.923,19.689-5.391,30.579-7.205
                                                      c4.975-0.825,10.082-1.5,15.291-1.974c3.663,3.431,7.621,6.555,11.939,9.164c3.363,2.069,6.94,3.816,10.684,5.119
                                                      c3.786,1.237,7.595,2.247,11.528,2.886c1.986,0.284,4.017,0.413,6.092,0.335c4.631-0.175,11.278-1.951,11.714-7.57
                                                      C231.127,152.765,230.756,151.257,230.013,149.935z M119.144,160.245c-2.169,3.36-4.261,6.382-6.232,9.041
                                                      c-4.827,6.568-10.34,14.369-18.322,17.286c-1.516,0.554-3.512,1.126-5.616,1.002c-1.874-0.11-3.722-0.937-3.637-3.065
                                                      c0.042-1.114,0.587-2.535,1.423-3.931c0.915-1.531,2.048-2.935,3.275-4.226c2.629-2.762,5.953-5.439,9.777-7.918
                                                      c5.865-3.805,12.867-7.23,20.672-10.286C120.035,158.858,119.587,159.564,119.144,160.245z M146.366,75.985
                                                      c-0.602-3.514-0.693-7.077-0.323-10.503c0.184-1.713,0.533-3.385,1.038-4.952c0.428-1.33,1.352-4.576,2.826-4.993
                                                      c2.43-0.688,3.177,4.529,3.452,6.005c1.566,8.396,0.186,17.733-1.693,25.969c-0.299,1.31-0.632,2.599-0.973,3.883
                                                      c-0.582-1.601-1.137-3.207-1.648-4.821C147.945,83.048,146.939,79.482,146.366,75.985z M163.049,142.265
                                                      c-9.13,1.48-17.815,3.419-25.979,5.708c0.983-0.275,5.475-8.788,6.477-10.555c4.721-8.315,8.583-17.042,11.358-26.197
                                                      c4.9,9.691,10.847,18.962,18.153,27.214c0.673,0.749,1.357,1.489,2.053,2.22C171.017,141.096,166.988,141.633,163.049,142.265z
                                                      M224.793,153.959c-0.334,1.805-4.189,2.837-5.988,3.121c-5.316,0.836-10.94,0.167-16.028-1.542
                                                      c-3.491-1.172-6.858-2.768-10.057-4.688c-3.18-1.921-6.155-4.181-8.936-6.673c3.429-0.206,6.9-0.341,10.388-0.275
                                                      c3.488,0.035,7.003,0.211,10.475,0.664c6.511,0.726,13.807,2.961,18.932,7.186C224.588,152.585,224.91,153.321,224.793,153.959z"/>
                                                  <polygon style="fill:#FB3449;" points="227.64,25.263 32.842,25.263 32.842,0 219.821,0 	"/>
                                                  <g>
                                                      <path style="fill:#A4A9AD;" d="M126.841,241.152c0,5.361-1.58,9.501-4.742,12.421c-3.162,2.921-7.652,4.381-13.472,4.381h-3.643
                                                          v15.917H92.022v-47.979h16.606c6.06,0,10.611,1.324,13.652,3.971C125.321,232.51,126.841,236.273,126.841,241.152z
                                                          M104.985,247.387h2.363c1.947,0,3.495-0.546,4.644-1.641c1.149-1.094,1.723-2.604,1.723-4.529c0-3.238-1.794-4.857-5.382-4.857
                                                          h-3.348C104.985,236.36,104.985,247.387,104.985,247.387z"/>
                                                      <path style="fill:#A4A9AD;" d="M175.215,248.864c0,8.007-2.205,14.177-6.613,18.509s-10.606,6.498-18.591,6.498h-15.523v-47.979
                                                          h16.606c7.701,0,13.646,1.969,17.836,5.907C173.119,235.737,175.215,241.426,175.215,248.864z M161.76,249.324
                                                          c0-4.398-0.87-7.657-2.609-9.78c-1.739-2.122-4.381-3.183-7.926-3.183h-3.773v26.877h2.888c3.939,0,6.826-1.143,8.664-3.43
                                                          C160.841,257.523,161.76,254.028,161.76,249.324z"/>
                                                      <path style="fill:#A4A9AD;" d="M196.579,273.871h-12.766v-47.979h28.355v10.403h-15.589v9.156h14.374v10.403h-14.374
                                                          L196.579,273.871L196.579,273.871z"/>
                                                  </g>
                                                  <polygon style="fill:#D1D3D3;" points="219.821,50.525 270.346,50.525 219.821,0 	"/>
                                              </g>
                                          </svg>
                                      </div>
                                  </ng-container>
                                    <ng-container *ngSwitchCase="'image'">
                                        <div class="img_wrp">
                                            <img (error)="onImgError($event)" [src]="host + (item?.discussion?.lastPost?.file?.thumbnail ? (item?.discussion?.lastPost?.file?.thumbnail + '?company_id=' + company?.id) : (item?.discussion?.lastPost?.file?.original + '?company_id=' + company?.id))" alt="">
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                      <ng-container *ngIf="!!item?.discussion?.lastPost?.file?.thumbnail; else elseTemplateHasThumb">
                                        <div class="img_wrp">
                                          <img (error)="onImgError($event)" [src]="host + item?.discussion?.lastPost?.file?.thumbnail  + '?company_id=' + company?.id" alt="">
                                        </div>
                                      </ng-container>
                                      <ng-template #elseTemplateHasThumb>
                                        <div class="file d-f-c">
                                          <mat-icon class="file_img_icon mr-1" style="color: #3f51b5">
                                              insert_drive_file
                                          </mat-icon>
                                      </div>
                                      </ng-template>
                                    </ng-container>
                                </ng-container>
                              </div>
                              <!-- <div class="file_info">
                                  <span class="file_name">{{ chat?.lastPost?.file?.filename }}</span>
                                  <span class="file_size">{{ chat?.lastPost?.file?.filesize | filesize }}</span>
                              </div> -->
    
                            </div>
                            
                            <!-- <div class="text_one_line">
                              {{ item?.discussion?.lastPost?.text }}
                            </div> -->
                            <div class="text_one_line" [innerHTML]='item?.discussion?.lastPost?.text ? (item?.discussion?.lastPost?.text.replaceAll("\n"," ").replaceAll("</BR>"," ").replaceAll("<BR>"," ").replaceAll("</br>"," ").replaceAll("<br>"," ")) : ""'></div>
                        </div>
                        </ng-template>
                      </ng-container>
                      <ng-template #elseTemplateItIsDisc>
                        <div class="empl_comment">
                          <ng-container *ngIf="item?.taskOperation?.employee_comment; else elseTemplateNBSP">
                            {{item?.taskOperation?.employee_comment}}
                          </ng-container>
                        </div>
                      </ng-template>
                      
    
                    </div>
                    <div class="task_name_wrp">
                      <div class="task_name text_one_line">
                        {{item?.task?.name}}
                      </div>
                      <div class="task_ids">
                        <div>{{item?.task?.internal_id}}</div>
                        <div>{{item?.task?.id}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="clients" *ngIf="item?.clients?.length > 0">
                    <div class="clients_title">
                      {{ "Clients" | translate }}:
                    </div>
                    <ng-container *ngFor="let client of item?.clients; let ind = index;">
                      <ng-container *ngIf="ind <= 2">
                        <app-user [class]="'client'" [employee]="client?.client"></app-user>
                      </ng-container>
                      
                      <div class="clients_more" *ngIf="ind == item?.clients?.length - 1 && ind > 2">
                        +{{ item?.clients?.length - 3}}
                      </div>
                    </ng-container>
    
                  </div>
                </div>
              </div>
            </div>
        </mat-tab>
        </mat-tab-group>
      </ng-template>
    <!-- <app-loader-more *ngIf="isLoad || boardLoad"></app-loader-more> -->
    <mat-progress-bar mode="indeterminate" *ngIf="isLoad" class="mat_proggress_w8"></mat-progress-bar>
</div>

<ng-template #elseTemplateNBSP>
  &nbsp;
</ng-template>